module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a"
  }, [_vm._v("CHAPTER I")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('i', [_vm._v("ENÛMA ELISH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Of All the Semitic inscriptions composed in cuneiform writing few have awakened as great a general interest as the epic known among the Babylonians and Assyrians as "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" (“When above”), which takes its name from the opening words of the poem. Aside from linguistic considerations, this widespread popularity of "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" is in part due to its great significance for the study of the theogonic and cosmogonic views of the Mesopotamians, and thus for a comparative study of ancient Near Eastern religion in general; but above all else it is due to the fact that "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" presents quite a number of analogies to the first two chapters of the Book of Genesis.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("THE DISCOVERY OF THE TABLETS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This great epic is recorded on seven clay tablets and covers in all a little over one thousand lines. The first fragments to come to light were discovered by Austen H. Layard, Hormuzd Rassam, and George Smith among the ruins of King Ashurbanipal’s (668–"), _c('i', [_vm._v("ca")]), _vm._v(". 630 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v(") great library at Nineveh between the years 1848 and 1876. During their explorations at Ashur (the old capital of Assyria), from 1902 to 1914, the German excavators unearthed a number of fragments of an Assyrian version of the Babylonian story (especially of Tablets I, VI, and VII) which differs from the latter chiefly in that some copies substitute the name of Ashur, the king of the Assyrian gods, for that of Marduk, the king of the Babylonian deities, and in that they make La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a.jpg"
    }
  }), _vm._v("mu and La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu the parents of Ashur. In 1924–25 two almost complete tablets, I and VI, of a Neo-Babylonian version of the epic were discovered at Kish by the joint expedition of Oxford University and the Field Museum of Chicago. And in 1928–29 the Germans found quite a large Neo-Babylonian fragment of Tablet VII at Uruk (the biblical Erech)."), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v(" Thanks to these discoveries and to purchases of fragments which have been made from dealers in antiquities (the provenance of most of these fragments being uncertain), the epic has been restored almost in its entirety; the only tablet of which a large portion is still wanting is Tablet V.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("THE PUBLICATION OF THE MATERIAL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first to publish an account of the epic was George Smith, of the British Museum, who in 1875 described in a letter to the "), _c('i', [_vm._v("Daily Telegraph")]), _vm._v(" the contents of about twenty fragments of the creation series. In 1876 appeared his book "), _c('i', [_vm._v("The Chaldean Account of Genesis")]), _vm._v(", which contained a translation and discussion of all the pieces which had been identified. All this material was very fragmentary, but the resemblance of its contents to the initial chapters of the Old Testament was unmistakable, and consequently it had an immediate appeal to a much wider circle of students than would otherwise have been the case. Since then this story has been copied and translated by a great many Assyriologists, especially as new tablets or portions of tablets have been found.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1890 Peter Jensen, in his work "), _c('i', [_vm._v("Die Kosmologie der Babylonier")]), _vm._v(" (Strassburg), published a translation together with a transliteration and a commentary; five years later Heinrich Zimmern issued a new and improved translation in Hermann Gunkel’s volume "), _c('i', [_vm._v("Sch"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ö")]), _vm._v("pfung und Chaos in Urzeit und Endzeit")]), _vm._v(" (G"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ö")]), _vm._v("ttingen, 1895); the very next year Friedrich Delitzsch issued "), _c('i', [_vm._v("Das babylonische Weltsch"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ö")]), _vm._v("pfungsepos")]), _vm._v(" (Leipzig, 1896). Within a few years this was superseded by Jensen’s penetrating and still highly valuable study of "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" in his book "), _c('i', [_vm._v("Assyrisch-babylonische Mythen und Epen")]), _vm._v(" (Berlin, 1900), containing a transliteration, a translation, and an extensive commentary. At the turn of the century, L. W. King issued a large number of creation fragments in his two volumes "), _c('i', [_vm._v("The Seven Tablets of Creation")]), _vm._v(" (London, 1902), the first of which contains chiefly transliterations, translations, and discussions, while the second offers cuneiform texts only.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More recent publications dealing with this subject are A. Ungnad, "), _c('i', [_vm._v("Die Religion der Babylonier und Assyrer")]), _vm._v(" (Jena, 1921);"), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v(" Erich Ebeling, "), _c('i', [_vm._v("Das babylonische Weltsch"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ö")]), _vm._v("pfungslied")]), _vm._v(" in Bruno Meissner, "), _c('i', [_vm._v("Altorientalische Texte und Untersuchungen")]), _vm._v(", II, 4 (Breslau, 1921); Ebeling’s revised rendition in Hugo Gressmann’s volume "), _c('i', [_vm._v("Altorientalische Texte zum Alten Testament")]), _vm._v(" (Berlin and Leipzig, 1926); S. Langdon, "), _c('i', [_vm._v("The Babylonian Epic of Creation")]), _vm._v(" (Oxford, 1923) and "), _c('i', [_vm._v("Babylonian Penitential Psalms to Which Are Added Fragments of the Epic of Creation from Kish")]), _vm._v(" (Paris, 1927); Sir E. A. Wallis Budge, "), _c('i', [_vm._v("The Babylonian Legends of the Creation")]), _vm._v(" (London, 1931); Anton Deimel, "), _c('i', [_vm._v("“Enuma Eli"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("š")]), _vm._v("” und Hexa"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ë")]), _vm._v("meron")]), _vm._v(" (Rome, 1934); G. Furlani, "), _c('i', [_vm._v("Il Poema della creazione")]), _vm._v(" (Bologna, 1934); and Ren"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("é")]), _vm._v(" Labat, "), _c('i', [_vm._v("Le Po"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("è")]), _vm._v("me babylonien de la cr"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("é")]), _vm._v("ation")]), _vm._v(" (Paris, 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The publications in which the cuneiform texts have been made available are for the most part cited in the studies just mentioned; the rest will be referred to in footnotes in the present volume.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("A SUMMARY OF THE STORY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The epic opens with a brief reference to the time when nothing except the divine parents, Apsû and Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, and their son Mummu existed. Apsû was the primeval sweet-water ocean, and Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat the salt-water ocean, while Mummu probably represented the mist rising from the two bodies of water and hovering over them, particularly since in Tablet VII: 86 he is brought in direct relation with the clouds. These three types of water were mingled in one, forming an immense, undefined mass in which were contained all the elements of which afterward the universe was made. As yet, there was neither heaven nor earth, not even a reed marsh was to be seen. In time, Apsû and Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat brought forth the brother and sister pair La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a.jpg"
    }
  }), _vm._v("mu and La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu. While these two were growing up, another brother and sister pair came into being, Anshar and Kishar, who surpassed the older children in stature. The nature of these two divine pairs is still a matter for conjecture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After many years, a son was born to Anshar and Kishar. They named him Anu, probably in allusion to the fact that he was the likeness of his father, Anshar. Anu was the sky-god. He, in turn, begot Nudimmud, his likeness. Nudimmud, also known as Enki and Ea, was a god of exceptional wisdom and"), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" strength; he became the god of the subterranean sweet waters, the god of magic, and the mastermind of the Mesopotamian divinities. He had no rival among his fellow-gods; in fact, because of the advantages with which he was endowed, he was the master even of his fathers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The younger gods, being full of life and vitality, naturally enjoyed noisy, hilarious gatherings. These, however, caused serious distress to their old, inactive, and rest-loving parents and grandparents, Apsû and Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat. Peaceful means were tried to diminish the disturbing clamor, but without success. Finally, Apsû, in utter exasperation, resolved on a drastic course of action. Accompanied by Mummu, his son and vizier, he went before Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat and submitted a plan to her which made her motherly heart cry out in painful rage: “Why should we destroy that which we ourselves have brought forth? Their way is indeed painful, but let us take it good-naturedly!” But Apsû, supported by his vizier, adhered to his expressed purpose with adamant tenacity: “I will destroy (them) and put an end to their way, that silence be established, and then let us sleep!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the break of the news, the gods were filled with consternation and ran about aimlessly. Finally, they quieted down and sat in silent gloom, without anyone being able to suggest a way of deliverance. Fortunately, in that dark hour there was found one who was master even of Apsû; it was Ea, “the one of supreme understanding, the skilful, (and) wise,” the god of magic. He made a magic circle of some kind around the gods, as a protection against attack, and then composed an overpowering, holy incantation. He recited it and caused it to descend, as a soporific force, upon Apsû. As Ea recited his incantation, Apsû succumbed to the power of the spell and sank into a profound sleep. And as Apsû was lying there, suffused with sleep, Ea removed his royal tiara and his supernatural radiance and clothed himself therewith. After he had thus come into possession of Apsû’s might and splendor, he slew the father of all the gods and imprisoned his vizier, gaining his victory chiefly through the application of authority or power inherent in the spoken word, the magic of the spell. Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat remained unmolested, since she had not been in sympathy with Apsû’s designs."), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" Upon the slain Apsû, Ea subsequently established a spacious abode. He named it “Apsû” and appointed it for shrines for himself and for other deities. There he and his wife, Damkina, dwelt in splendor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There also it was that Marduk, “the wisest of the gods,” was born, the one who was destined some day to deliver the gods from an even more dreadful foe and to become the head of the vast Babylonian pantheon. “He who begot him was Ea, his father. Damki[na], his mother, was she who bore him. He sucked the breasts of goddesses” and thus imbibed additional divine power and qualities. Marduk was an imposing figure, endowed with flashing eye and awe-inspiring majesty. When his father beheld him, “he rejoiced, he beamed, his heart was filled with joy.” Evidently by means of magic, Ea then conferred upon his son double equality with the gods, which manifested itself in the two faces of Marduk and the doubled dimensions of his members, so that “he was exalted among the gods.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the meantime, Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat was disturbed, doubtless because of the violent death of her husband. Day and night, she restlessly moved about. Her restlessness mounted as some of the gods, led by Kingu (cf. Tablet VI:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabVI-23"
    }
  }, [_vm._v("23–30")]), _vm._v("), in their wickedness instigated her to avenge the death of her spouse. Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat yielded and decided on war against the gods who were either responsible for or in sympathy with the murder of her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rebel gods now publicly seceded and went over to the side of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat; they raged and plotted, not resting day or night; “they held a meeting and planned the conflict.” Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, on her part, gave birth to eleven kinds of monster serpents and ferocious dragons for the impending contest; she exalted Kingu to be her new spouse, she intrusted him with the high command of the battle, gave him dominion over all the gods, and presented him with the coveted tablet of destinies with all its magic powers. A formidable demonic host had suddenly sprung into existence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was not until Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat was almost ready for the assault that someone informed Ea of the imminent peril. When Ea, the wise and skilful, the hero who had vanquished Apsû, heard of the impending danger, he was benumbed with fear and dismay."), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" When he had thought the matter over and had regained his composure, he went to Anshar, his grandfather, and “communicated to him all that Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat had planned” and the preparations she had made, repeating word for word the report which he himself had received. Anshar was moved to expressions of deepest grief and grave concern and appealed to Ea to proceed against the foe. Ea obeyed the voice of his grandfather, but the venture, though undertaken by him who had achieved such a decisive victory over Apsû, ended in failure. Anshar then turned to his son Anu, urging him to try peaceful measures, saying: “[Go a]nd stand thou before Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, [that] her spirit [become quiet and] her heart calm down. [If] she does not hearken to thy word, speak our [word(?)] to her, that she may be quieted.” Anu went, armed with his own authority and that of the leader of the gods. But, unlike Apsû, Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat could not be overcome by any amount of mere authority or any degree of mere magic power; she had to be conquered through the application of physical force. Anu returned in terror, asking to be relieved of the task. Anshar lapsed into silence, looking upon the ground and shaking his head. “All the Anunnaki were assembled at the place. Their lips were closed, [they sat in] silence.” Never before had the gods been in such a plight. The picture is painted in extremely dark and somber colors to make the greatness of the subsequent victory all the more evident.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this moment of supreme crisis, a happy thought occurred to Anshar; he remembered the prowess of valiant Marduk, who in some way had already proved his valor (cf. Tablet II:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabII-95"
    }
  }, [_vm._v("95")]), _vm._v(") and who certainly would not fail. Marduk was summoned into the presence of Ea, to be instructed by his father, and then appeared before Anshar. When Anshar saw the young Marduk, abounding in strength and radiating confidence, “his heart was filled with joy; he kissed his lips, his fear was removed,” while Marduk assured him: “[Anshar], be not silent, (but) open thy lips; I will go and accomplish all that is in thy heart! [My father, c]reator, be glad and rejoice; soon thou shalt trample upon the neck of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat!” There was no doubt in anyone’s mind that Marduk, despite his youth, could save the gods from their powerful enemy. Moreover, Marduk was ready to go to"), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" battle and deliver the gods from disaster. But he demanded a high price—supreme and undisputed authority among the gods. Anshar agreed to the terms (cf. Tablet III:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabIII-65"
    }
  }, [_vm._v("65–66")]), _vm._v("), but the decision had to be confirmed by the gods in their assembly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anshar therefore dispatched Kaka, his vizier, to La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a.jpg"
    }
  }), _vm._v("mu and La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu and all the other gods who were living at a great distance and, consequently, had as yet no knowledge of the impending struggle. Kaka was to inform the gods of the gravity of the situation and to summon them into the presence of Anshar. After a few prefatory remarks, Anshar gave Kaka a verbatim repetition of the account of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat’s hostile activities and charged him to repeat the message word for word to La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a.jpg"
    }
  }), _vm._v("mu and La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu. Kaka went and repeated Anshar’s speech in every detail."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn1",
      "id": "ffn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Upon learning of the sudden and unparalleled crisis, the gods were perplexed and horrified, they cried aloud and wailed painfully. They departed and entered into the presence of Anshar, filling the Court of Assembly. They kissed one another as they met, and then sat down to a banquet, which Anshar had prepared to put the gods in the right frame of mind. “The sweet wine dispelled their fears; [their] bod[ies] swelled as they drank the strong drink. Exceedingly carefree were they, their spirit was exalted; for Marduk, their avenger, they decreed the destiny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the feast, the gods erected a lordly throne-dais for Marduk, and the young god sat down before his fathers to receive sovereignty. In a solemn speech, the gods conferred upon him the powers of the supreme position in the pantheon and gave him “kingship over the totality of the whole universe.” To determine whether Marduk actually had this power, the gods made a test. They placed a garment in their midst. At his command, the garment was destroyed; again at his command, the garment was restored to its former condition. When the gods beheld the efficacy of his word, they rejoiced and paid homage,"), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" acclaiming Marduk king of the gods. They invested him with the royal insignia, the scepter, the throne, and the royal robe(?), adding thereto “an irresistible weapon smiting the enemy,” with the plea: “Go and cut off the life of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marduk departed to prepare for the fray. He made a bow, put an arrowhead on the arrow, and grasped a club in his right hand; the bow and quiver he hung at his side; like the storm-god, he caused lightning to precede him; he filled his body with a blazing flame; he made a net and had the four winds, the gift of Anu, carry it for him; as a further aid, he created seven winds of his own; he raised the rain-flood and mounted his irresistible, terrible storm chariot, drawn by four frightful mythological creatures. Clad in a terrifying coat of mail, with an overpowering brightness about his head, and supplied with various apotropaic means, Marduk then set out to meet the seemingly invincible Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, the gods milling around him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The mere appearance of Marduk, arrayed in all his terrifying might and dazzling splendor, threw Kingu and his helpers into confusion. Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat alone remained unperturbed, greeting Marduk with awful taunts and apparently a loud roar to frighten the youthful god. But Marduk was of tougher fiber than his father Ea and his grandfather Anu. Without being in the least disturbed, he denounced Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat in trenchant terms for her wicked measures and challenged her to a duel! “When Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat heard this, she became like one in a frenzy (and) lost her reason. She cried out loud (and) furiously,” shaking to her very foundations! But she accepted the challenge, and the two pressed on to single combat. Marduk spread out his net and enmeshed her. “When Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat opened her mouth to devour him, he drove in the evil wind, in order that (she should) not (be able) to close her lips.” As the raging winds distended her body, Marduk shot an arrow through her open mouth; it struck her heart and destroyed her life. Having thus killed Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, he cast down her carcass and victoriously stood upon it. When her followers saw that their leader was dead, they dispersed and tried to flee. But none escaped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The enemy gods were imprisoned and deprived of their"), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" weapons. Marduk took from Kingu the tablet of destinies, sealed it with his own seal, to prove his ownership and to legalize his claim to it, and fastened it on his breast. After having strengthened his hold upon the captive gods, he returned to Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, split her skull with his unsparing club, cut her arteries, and caused the north wind to carry her blood southward to out-of-the-way places. Finally, he divided the colossal body of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat into two parts to create the universe. With one half of her corpse he formed the sky, with the other he fashioned the earth, and then established Anu, Enlil, and Ea in their respective domains.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next, he created stations in the sky for the great gods; he organized the calendar, by setting up stellar constellations to determine, by their rising and setting, the year, the months, and the days; he built gates in the east and in the west for the sun to enter and to depart; in the very center of the sky he fixed the zenith; he caused the moon to shine forth and intrusted the night to her. After some detailed orders to the moon, the tablet dealing with the creation and organization of the heavenly bodies breaks off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The imprisoned gods, who had joined the ranks of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, were made the servants of the victors, for whose sustenance they had to provide. However, their menial task proved so burdensome that they asked Marduk for relief. As Marduk listened to the words of the captive gods, he resolved to create man and to impose on him the service which the defeated deities had to render. In consultation with Ea, it was then decided to kill the ringleader of the rebels, to create mankind with his blood, and to set the captive gods free. In a solemn court Kingu was indicted. He it was who “created the strife,” who “caused Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat to revolt and prepare for battle.” Accordingly, Kingu was bound and brought before Ea. With the aid of certain gods, Ea severed his arteries and created mankind with his blood, acting on the ingenious plans of Marduk. Man now had to take over the work of the defeated army of gods and feed the host of Babylonian divinities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next, Marduk divided the totality of the Anunnaki, a name"), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v(" which in the early period seems to have been a general designation for all the gods of heaven and earth. Marduk set three hundred of them in the heavens, and three hundred he assigned to the earth, allotting to each group their appropriate tasks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a token of gratitude for their deliverance at the hands of Marduk, the Anunnaki built the city of Babylon and Marduk’s great temple Esagila with its stagetower. Then the gods, after a joyful banquet, in solemn assembly, recited the fifty names of Marduk. As the gods had previously met in the Court of Assembly to invest Marduk with supreme regal power and authority before he set out against Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, so they were gathered again in the same place to confer upon him fifty titles with all the attributes and abilities of the various gods of the pantheon, thus making “his way pre-eminent,” in further appreciation of all that Marduk had done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The poem closes with an epilogue urging the people to study these names, to hold them in remembrance, and to rejoice in Marduk, that it may be well with them."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn2",
      "id": "ffn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("THE OBJECT OF THE EPIC")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Enûma elish")]), _vm._v(" is the principal source of our knowledge of Mesopotamian cosmology. While the various other creation stories treat of certain aspects of the cosmos, "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" gives us an account of the origin and the order of the universe as a whole. The universe, in its component parts, begins with the gods, who represent cosmic elements or forces in nature (although the character of some of the gods is still uncertain), and is organized and completed through the creative activities of Marduk, the author of the present world order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet, "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" is not primarily a creation story at all. If we were to put together all the lines which treat of creation, including the theogony and even granting that most of the missing portion of Tablet V deals with works of creation, they would cover not even two of the seven tablets but only about as much space as is devoted to Marduk’s fifty names in Tablets VI and VII. The brief and meager account of Marduk’s acts of creation"), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" is in sharp contrast to the circumstantial description of his birth and growth, his preparations for battle, his conquest of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat and her host, and the elaborate and pompous proclamation and explanation of his fifty names. If the creation of the universe were the prime purpose of the epic, much more emphasis should have been placed on this point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As it is, there can be no doubt that, in its present form, "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" is first and foremost a literary monument in honor of Marduk as the champion of the gods and the creator of heaven and earth. Its prime object is to offer cosmological reasons for Marduk’s advancement from the position as chief god of Babylon to that of head of the entire Babylonian pantheon. This was achieved by attributing to him the defeat of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat and the creation and maintenance of the universe. The description of the birth of the gods and of the subsequent struggle between Ea and Apsû and the account of the origin of the universe were added mainly for the purpose of furthering the cause of Marduk; the former was included as the antecedent to Marduk’s conflict with Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat and his accession to supreme power among the gods, while the latter, the story of the creation of the universe, was added not so much for the sake of giving an account of how all things came into being, but chiefly because it further served to enhance the glory of Marduk and helped to justify his claim to sovereignty over all things visible and invisible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next to the purpose of singing the praises of Marduk comes the desire, on the part of the Babylonian priests, who were responsible for the composition of this epic, to sing the praises of Babylon, the city of Marduk, and to strengthen her claim to supremacy over all the cities of the land. Babylon’s claim to supremacy was justified already by the fact that it was Babylon’s god who had conquered Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat and had created and organized the universe. It was further supported by tracing Babylon’s origin back to the very beginnings of time and by attributing her foundation to the great Anunnaki themselves, who built Babylon as a dwelling place for Marduk and the gods in general (Tablet VI:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabVI-45"
    }
  }, [_vm._v("45–73")]), _vm._v("). Our epic is thus not only a religious treatise but also a political one."), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("THE SOURCES OF THE EPIC")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is generally admitted that "), _c('i', [_vm._v("Enûma elish")]), _vm._v(", though it is one of the literary masterpieces of the Babylonian Semites, is undoubtedly based on the cosmology of the Sumerians and that the central figure of the Sumerian story was Enlil, the most important god in Babylonia until Marduk’s rise to supremacy. For not only do all the gods, with the exception of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, appear to have Sumerian names but some of the gods themselves, such as Apsû, Anu, and Enlil, are admittedly Sumerian. Moreover, the majority of the monsters which Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat bore (Tablet I:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabI-132"
    }
  }, [_vm._v("132–42")]), _vm._v(") and almost all the winds created by Marduk (Tablet IV:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabIV-45"
    }
  }, [_vm._v("45–46")]), _vm._v(") likewise have Sumerian names. Even man himself is called by a Sumerian term, "), _c('i', [_vm._v("lullû")]), _vm._v(", which is immediately translated by the Semitic "), _c('i', [_vm._v("am"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ê")]), _vm._v("lu")]), _vm._v(" (Tablet VI:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabVI-6"
    }
  }, [_vm._v("6–7")]), _vm._v(")."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn3",
      "id": "ffn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Furthermore, the separation of the primeval world matter into heaven and earth is a feat which the Sumerians ascribed to Enlil, the personified air, for it is the atmosphere which, placed between the sky and the earth, holds them apart."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn4",
      "id": "ffn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Another important point to be considered in this connection is the fact that the Semites in Babylonia became in general the heirs of the Sumerians, and as such they took over, with certain modifications, their script and literature, their religion, their culture and civilization. But how much of "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" must be traced to Sumerian sources cannot be ascertained with any degree of finality until Sumerian cosmology is better known as to both content and origin, for, as S. N. Kramer has remarked,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn5",
      "id": "ffn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" it is quite possible that there are “traces of Semitic influence in even the earliest known Sumerian mythology just as we find them in case of the Sumerian language.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn6",
      "id": "ffn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("THE DATE OF COMPOSITION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When our poem was composed in approximately its present Semitic form we cannot as yet determine with certainty. The tablets and fragments from Ashurbanipal’s library at Nineveh belong to the seventh century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v("; those from the city of Ashur date back to approximately 1000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v("; while those from Kish, the fragment from Uruk, and those of uncertain provenance belong to the sixth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v(" and later. But all these tablets are copies of older ones, as indicated by the colophons at the ends of the different tablets and by the fact that on the tablets from Ashur the scribes usually retained the name of Marduk, instead of substituting for it that of the god of Ashur, which shows that they copied from Babylonian originals. The date for the composition of our epic must therefore be pushed back beyond the date of the oldest copies at our disposal, and that will bring it somewhere beyond 1000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, we have reason to push it back much further. The inscription of Agum II (fifteenth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v("), the ninth king of the Kassite Dynasty, following almost immediately upon the First Babylonian Dynasty, seems to show that "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" existed already during the fifteenth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v(" In this inscription Agum records the restoration of the statues of Marduk and his consort "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int9.jpg"
    }
  }), _vm._v("arpan"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("î")]), _vm._v("tu, which had been carried away to the land "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int7a.jpg"
    }
  }), _vm._v("an"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("î")]), _vm._v(", and describes the works of art with which he embellished the statues and sanctuaries of these two divinities. He states, among other things, that on the panels of the doors of the holy chambers he had his craftsmen represent a number of monsters. He mentions the viper, the "), _c('i', [_vm._v("la"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _vm._v("mu")]), _vm._v(", the bison, the great lion, the mad dog, the dragonfly, and the goat-fish. These monsters, with the exception of the goat-fish, are identical with those which Marduk vanquished in his combat with Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat (Tablet I:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabI-140"
    }
  }, [_vm._v("140–43")]), _vm._v("). This similarity alone, of course, proves nothing as to the date of "), _c('i', [_vm._v("Enûma elish")]), _vm._v(", because one could easily argue that the monsters in question formed part of general Babylonian mythology and that both passages reverted to the same fountain-head. But their association with Marduk seems to reveal the influence"), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" of "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" and, consequently, seems to indicate that our epic was composed at least before the end of Agum’s reign."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn7",
      "id": "ffn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But we have better reasons than this for assuming an even earlier date. For if we consider that the two main objects of the epic are to justify Marduk’s ascendancy to supreme rulership over all the Babylonian divinities and to support Babylon’s claim to pre-eminence above all the other cities in the country, as we have seen, and that Babylon rose to political supremacy during the First Babylonian Dynasty (1894–1595),"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn8",
      "id": "ffn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" particularly under the energetic king Hammurabi (1792–1750), and that during this dynasty Marduk became the national god,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn9",
      "id": "ffn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" it would seem that the poem, in approximately its present form, was composed some time during the First Babylonian Dynasty. The language of the epic points in the same direction, as observed by W. von Soden."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn10",
      "id": "ffn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("THE METER OF THE POEM")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Our epic was intended for recitation. Hence it was cast into poetry, since this is the most appealing and most effective method of expression for that purpose. Babylonian poetry, like Hebrew, has no rhyme, but it has rhythm, or meter. In accordance with the rules of Babylonian poetry, the lines fall into distichs, or couplets, as we can see, for example, from the fact that, where space permits it, the two verses forming a couplet are frequently written on the same line, separated by two small dividing wedges. The second line of a distich usually forms a contrast, a parallel, or a supplement to the first, as exemplified by the following lines of the creation story:")]), _vm._v(" "), _c('p', {
    staticClass: "ref1"
  }, [_c('i', [_vm._v("Tablet I:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabI-1"
    }
  }, [_vm._v("1–2")]), _vm._v(":")]), _vm._v(" When above the heaven had not (yet) been named, (And) below the earth had not (yet) been called by a name;")]), _vm._v(" "), _c('p', {
    staticClass: "ref1"
  }, [_c('i', [_vm._v("Tablet I:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabI-25"
    }
  }, [_vm._v("25–26")]), _vm._v(":")]), _vm._v(" Apsû could not diminish their clamor, And Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat was silent in regard to their [behavior];")]), _vm._v(" "), _c('p', {
    staticClass: "ref1"
  }, [_c('i', [_vm._v("Tablet I:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabI-33"
    }
  }, [_vm._v("33–34")]), _vm._v(":")]), _vm._v(" They went and reposed before Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat; They took counsel concerning the gods, their first-born.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenttb"
  }, [_vm._v("Quite frequently two distichs unite to form a quatrain, or a stanza of four lines. Compare, for example, Tablet I: 37–40:")]), _vm._v(" "), _c('p', {
    staticClass: "poemtt"
  }, [_vm._v("Their way has become painful to me,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("By day I cannot rest, by night I cannot sleep;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I will destroy (them) and put an end to their way,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("That silence be established, and then let us sleep!")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("In our epic, each of the two lines, or verses, of a distich falls into halves, divided by a well-marked caesura, and each half of a line may again be divided into two parts, each of which contains, as a rule, a single accented word or phrase. In "), _c('i', [_vm._v("Enûma elish")]), _vm._v(", as Benno Landsberger pointed out in a meeting of the Assyrian Dictionary staff, the final accent of a line usually rests on the second-last syllable, hardly ever on the last or the third-last syllable (on the last syllable are accented, e.g., Tablet IV:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabIV-19"
    }
  }, [_vm._v("19")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabIV-49"
    }
  }, [_vm._v("49")]), _vm._v("; on the third-last syllable, e.g., Tablets I:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabI-42"
    }
  }, [_vm._v("42")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabI-48"
    }
  }, [_vm._v("48")]), _vm._v("; II:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabII-4"
    }
  }, [_vm._v("4")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabII-107"
    }
  }, [_vm._v("107")]), _vm._v("; and III:"), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabIII-58"
    }
  }, [_vm._v("58")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That this fourfold division of each line actually exists is clear from the tablet Sp. II. 265"), _c('i', [_vm._v("a")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn11",
      "id": "ffn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v("—which, however, has nothing to"), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v(" do with the creation story—on which the scribe has drawn a vertical line not only after the half-verses but also after each quarter-verse. Some of the scribes who copied "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" left a space between the halves of each line and so divided each verse into two main parts, thus indicating at least the caesura in the middle of each verse. This fourfold division of each line, together with its four accents, can well be illustrated by the first two verses of our poem:")]), _vm._v(" "), _c('p', {
    staticClass: "image",
    attrs: {
      "id": "ffn12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "img/t26.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("“ENÛMA ELISH” AND THE NEW YEAR’S FESTIVAL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At the end of the fourth day of the New Year’s celebration in Babylon, which lasted from the first to the eleventh of Nisan, "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" was recited in its entirety by the high priest before the statue of Marduk."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn13",
      "id": "ffn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Then in the course of the festival, on an undetermined day, "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" was again recited, or chanted. Parts of the epic may even have been dramatized, the king and the priests playing the roles of Marduk, Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, Kingu, and other figures in the story.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reason for the second recitation of the epic is expressly stated in "), _c('i', [_vm._v("Keilschrifttexte aus Assur religi"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ö")]), _vm._v("sen Inhalts")]), _vm._v(", Nos. 143: 34 and 219:8: “"), _c('i', [_vm._v("Enûma elish")]), _vm._v(" which is recited before B"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ê")]), _vm._v("l, which they chant in the month of Nisan, (it is) because he is held prisoner.” The chanting of the epic is here apparently intended as a magical aid in Marduk’s deliverance from imprisonment, the precise nature of which is not clear."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn14",
      "id": "ffn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reason for the first recitation, on the fourth of Nisan, is not given in any of the available cuneiform sources. We are therefore dependent on conjecture."), _c('a', {
    attrs: {
      "id": "page_17"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("S. A. Pallis"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn15",
      "id": "ffn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" has suggested that the recital was for the purpose of exorcising all that is evil, just as the Babylonian creation myth “When Anu had created the heavens” was recited to keep away the evil influence of the demons during and after the restoration of the temple, by proclaiming the might and power of the gods (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_11_ch2#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 65")]), _vm._v(" of this book). However, the proper time for a recital with this object in view would have been the first day of the festival, and it is unlikely that this ceremony was performed twice for the same purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is possible that on this occasion the epic was recited as a magic formula against the coming inundation of Babylonia caused by the rise of the Tigris and the Euphrates following the melting of the snows in the mountains of Armenia and Kurdistan; for at the time of these floods it seemed as if the primordial chaotic condition of “water, water everywhere” were to return. This possibility is suggested by Tablet VII: "), _c('a', {
    attrs: {
      "href": "#/xhtml/#tabVII-132"
    }
  }, [_vm._v("132–34")]), _vm._v(": “May he subdue Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, may he distress her life, and may it be short! Until future (generations of) men, when the (present) days have grown old, may she retreat without hindrance, may she withdraw forever!” The recitation of "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" presumably reflects the annual battle between Marduk and the watery chaos produced by the spring inundations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other hand, it is also possible that the recitation and the supposed partial dramatization of "), _c('i', [_vm._v("Enûma elish")]), _vm._v(" were in honor of Marduk. For this was the festival of Marduk, the creator of the present world order; it was the season when the various gods of the land came to Babylon “to take the hands” of Marduk."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn16",
      "id": "ffn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" At the same time it was probably the hope of the Babylonians that this manifestation of their devotion to the king of the gods would assure a more favorable destiny for their country, especially considering that it was during this festival, on the eighth and the ninth of Nisan, that the destinies of the land were determined for the ensuing year."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn17",
      "id": "ffn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("TABLET I")]), _vm._v(" "), _c('p', {
    staticClass: "list",
    attrs: {
      "id": "tabI-1"
    }
  }, [_vm._v("1. When above the heaven had not (yet) been named,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn18",
      "id": "ffn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("2. (And) below the earth had not (yet) been called by a name;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("3. (When) Apsû primeval, their begetter,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn19",
      "id": "ffn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("4. Mummu,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn20",
      "id": "ffn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" (and) Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, she who gave birth to them all,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("5. (Still) mingled their waters together,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("6. And no pasture land had been formed (and) not (even) a reed marsh was to be seen;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("7. When none of the (other) gods had been brought into being,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("8. (When) they had not (yet) been called by (their) name(s, and their) destinies had not (yet) been fixed,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("9. (At that time) were the gods created within them."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn21",
      "id": "ffn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("10. La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _vm._v("mu and La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu came into being; they were called by (their) names."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn22",
      "id": "ffn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("11. Even before they had grown up (and) become tall,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("12. Anshar and Kishar were created; they surpassed them (in stature).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("13. They lived many days, adding years (to days).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("14. Anu was their heir presumptive, the rival of his fathers;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("15. Yea, Anu, his first-born, equaled Anshar."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn23",
      "id": "ffn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("16. And Anu begot Nudimmud,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn24",
      "id": "ffn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" his likeness.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("17. Nudimmud, the master of his fathers was he;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn25",
      "id": "ffn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("18. He was broad of understanding, wise, mighty in strength,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("19. Much stronger than his grandfather, Anshar;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("20. He had no rival among the gods his brothers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn26",
      "id": "ffn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("21. The divine brothers gathered together.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("22. They disturbed Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat and assaulted(?) their keeper;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn27",
      "id": "ffn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("23. Yea, they disturbed the inner parts of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("24. Moving (and) running about"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn28",
      "id": "ffn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27a")])]), _vm._v(" in the divine abode(?).")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-25"
    }
  }, [_vm._v("25. Apsû could not diminish their clamor,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("26. And Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat was silent in regard to their [behavior].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("27. Yet, their doing was painful [to them].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("28. Their way was not good. . . . .")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("29. Then Apsû, the begetter of the great gods,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("30. Called Mummu, his vizier, and said to him:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("31. “Mummu, my vizier, who gladdenest my heart,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("32. Come, let us [go] to Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-33"
    }
  }, [_vm._v("33. They went and reposed before Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("34. They took counsel about the matter concerning the gods, their first-born.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("35. Apsû opened his mouth")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("36. And said to Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat in a loud voice:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("37. “Their way has become painful to me,")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-38"
    }
  }, [_vm._v("38. By day I cannot rest, by night I cannot sleep;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("39. I will destroy (them) and put an end to their way,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("40. That silence be established, and then let us sleep!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("41. When Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat heard this,")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-42"
    }
  }, [_vm._v("42. She was wroth and cried out to her husband;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("43. She cried out and raged furiously, she alone.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("44. She pondered the evil in her heart (and said):")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("45. “Why should we destroy that which we ourselves have brought forth?")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("46. Their way is indeed very painful, but let us take it good-naturedly!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("47. Mummu spoke up and counseled Apsû;")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-48"
    }
  }, [_vm._v("48. [. . . .] and unfavorable was the advice of his Mummu:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("49. “Yes, my father, destroy (their) disorderly way;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("50. (Then) verily thou shalt have rest by day (and) sleep by night!”"), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("51. When Apsû [hear]d it, his face grew bright,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("52. Because of the evil he planned against the gods his children.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("53. Mummu embraced [his] neck,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("54. Sat down on his knee, and kissed him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("55. Whatever they planned in their assembly")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("56. Was communicated to the gods, their first-born.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("57. When the gods heard (it), they hasten(ed) about;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("58. They took to silence, they sat quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-59"
    }
  }, [_vm._v("59. The one of supreme understanding, the skilful (and) wise,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("60. Ea, who understands everything, saw through their plan."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn29",
      "id": "ffn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("61. He made and established against it a magical circle for all.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("62. He skilfully composed his overpowering, holy incantation.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("63. He recited it and thus caused (it) to be upon the water."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn30",
      "id": "ffn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("64. He poured out sleep upon him, (so that) he slept soundly."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn31",
      "id": "ffn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("65. When he had put Apsû to sleep, (Apsû) being suffused with sleep,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("66. Mummu, his adviser,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn32",
      "id": "ffn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(". . . . .")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("67. He loosened his band (and) tore off [his] tiara;")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-68"
    }
  }, [_vm._v("68. He carried off his splendor"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn33",
      "id": "ffn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" (and) put (it) on himself."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn34",
      "id": "ffn34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-69"
    }
  }, [_vm._v("69. When he had (thus) subdued Apsû, he slew him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("70. Mummu he shut in (and) barred (the door) against him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("71. On Apsû he established his dwelling place;"), _c('a', {
    attrs: {
      "id": "page_21"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("72. Mummu he seized for himself, holding (him) by his nose-rope.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("73. After Ea had vanquished (and) subdued his enemies,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("74. Had established his victory over his foes,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("75. (And) had peacefully rested in his abode,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("76. He named it "), _c('i', [_vm._v("Apsû")]), _vm._v(" and appointed (it) for shrines.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("77. In his place he founded his chamber;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("78. (There) Ea (and) Damkina, his wife, dwelt in splendor.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("79. In the chamber of fates, the abode of destinies,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("80. The wisest of the wise, the wisest of the gods, "), _c('i', [_vm._v("the")]), _vm._v(" god was begotten.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("81. Within the "), _c('i', [_vm._v("Apsû")]), _vm._v(" Marduk was born;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("82. Within the holy "), _c('i', [_vm._v("Apsû")]), _vm._v(" [Marduk] was born.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("83. He who begot him was Ea, his father;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("84. Damki[na], his mother, was she who bore him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("85. He sucked"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn35",
      "id": "ffn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" the breasts of goddesses.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("86. The nurse that cared for him filled (him) with awe-inspiring majesty.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("87. Enticing was his figure, flashing the look of his eyes,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("88. Manly was his going-forth, a leader(?)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn36",
      "id": "ffn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" from the beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("89. When E[a], his father that begot (him), saw him,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("90. He rejoiced, he beamed, his heart was filled with joy.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("91. He distinguished(?) him and con[ferred upon him(?)] dou[ble] equality with the gods,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("92. (So that) he was highly exalted (and) surpassed them in everything.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("93. Artfully arranged beyond comprehension were his members,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("94. Not fit for (human) understanding, hard to look upon.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("95. Four were his eyes, four were his ears."), _c('a', {
    attrs: {
      "id": "page_22"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("96. When his lips moved, fire blazed forth.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("97. Each of (his) four ears grew large,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("98. And likewise (his) eyes, to see everything.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("99. He was exalted among the gods, surpassing was [his] form;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("100. His members were gigantic, he was surpassing in height.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("101. M"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("riyûtu, M"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("riyûtu:")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-102"
    }
  }, [_vm._v("102. Son of the sun-god, the sun-god of the go[ds]!"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn37",
      "id": "ffn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("103. He was clothed with the rays of ten gods, exceedingly powerful was he;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("104. The te[rror-inspiring ma]jesty with its consuming brightness(?) rested upon him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("105. [. . . .] the four winds did Anu create,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("106. To restrain with his [. . . .] the strong(est) of the host."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn38",
      "id": "ffn38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("107. He caused waves and disturbed Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("108. Disturbed is Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, and day and night she (restlessly) hastens about.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("109. "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v("The gods"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(" were not at rest, carrying on(?) like the storm(?);")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("110. They planned evil in their heart(s).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("111. They said to Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, their mother:"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn39",
      "id": "ffn39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37a")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("112. “When they slew Apsû, thy spouse,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("113. Thou didst not march at his side, but thou didst sit quietly."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn40",
      "id": "ffn40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("114. He made . . . . fear."), _c('a', {
    attrs: {
      "id": "page_23"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("115. Disturbed is thine interior, and we cannot rest.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("116. Remember(?) Apsû, thy spouse,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("117. And Mummu, who were vanquished; thou dwellest alone."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn41",
      "id": "ffn41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("118. Thou art [not a m[other], rest[less]ly thou runnest about.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("119. [. . . .] thou dost not love us (anymore).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("120. [. . . .] . . . ., our eyes are heavy.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("121. [. . . .] without ceasing(?) let us sleep!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("122. [Go to batt]le(?) (and) requite them!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("123. [. . . .] and give (them) over to the storm!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("124. [When] Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat [heard it], the word pleased her,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn42",
      "id": "ffn42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("125. [And she said: “. . . .] . . . . let us make storm.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("126. [. . . .] and the gods in the midst of [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("127. [. . . . let us] make war, against the gods let us [. . . .]!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("128. They [separated themselves(?)] and went to the side of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("129. They [were angry], they plotted, not resting day or [night];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("130. They [took up] the fight, fuming (and) raging;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("131. They held a meeting and planned the conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-132"
    }
  }, [_vm._v("132. Mother "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int7a1.jpg"
    }
  }), _vm._v("ubur,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn43",
      "id": "ffn43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" who fashions all things,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("133. Added (thereto) irresistible weapons, bearing monster serpents")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("134. [Sharp] of tooth (and) not sparing the fang(?).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("135. [With poison] instead of blood she filled [their] bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("136. Ferocious [dra]gons she cl[othed] with terror,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("137. She crowned (them) with fear-inspiring glory (and) made (them) like gods,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("138. So that he who would look upon them should pe[rish] from terror,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("139. So that their bodies might leap forward and none turn back [their breasts].")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-140"
    }
  }, [_vm._v("140. She set up the viper, the dragon, and the "), _c('i', [_vm._v("la"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu")]), _vm._v(","), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn44",
      "id": "ffn44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("141. The great lion,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn45",
      "id": "ffn45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" the mad dog,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" and the scorpion-man,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("142. Driving storm demons, the dragonfly, and the bis[on],"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn46",
      "id": "ffn46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("143. Bearing unsparing weapons, unafraid of ba[ttle].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("144. Powerful were her decrees, irresistible were they.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("145. Altogether(?) eleven (kinds of monsters) of this sort she brought [into being].")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabI-146"
    }
  }, [_vm._v("146. Of those among the gods, her"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn47",
      "id": "ffn47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" first-born, who formed her [assembly],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("147. She exalted Kingu; in their midst she made him great.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("148. To march at the head of the army, to direct the for[ces],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("149. To raise the weapons for the engagement, to launch the attack,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("150. The high command of the battle,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("151. She intrusted to his hand; she caused him to sit in the assembly, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("152. “I have cast the spell for thee, I have made thee great in the assembly of the gods.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("153. The dominion over all the gods I have given into thy hand.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("154. Mayest thou be highly exalted, thou, my unique spouse!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("155. May thy names become greater than (those of) all the Anunnaki!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("156. She gave him the tablet of destinies, she fastened (it) upon his breast, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("157. “As for thee, thy command shall not be changed, [the word of thy mouth] shall be dependable!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("158. Now when Kingu had been exalted (and) had received [supreme dominion],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("159. [They"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn48",
      "id": "ffn48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" decreed] the destinies to the gods, her sons,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn49",
      "id": "ffn49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("160. “May the opening of your mouths [quiet] the fire-god!"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn50",
      "id": "ffn50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("161. May thy overpowering poison vanquish the (opposing) might!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn51",
      "id": "ffn51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("CATCH LINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat had made strong [preparations].")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("COLOPHON I")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("1. First tablet of "), _c('i', [_vm._v("Enûma elish;")]), _vm._v(" [written] like [its] original [and collated].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("2. The tablet of Nabû-bal"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int11.jpg"
    }
  }), _vm._v("su-iqb"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("î")]), _vm._v(", the son of Na"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _vm._v("id-Ma[rduk].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("3. By the hand of Nabû-bal"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int11.jpg"
    }
  }), _vm._v("su-iqb"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("î")]), _vm._v(", the son of "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v("Na"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _vm._v("id-Marduk. . . ."), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("COLOPHON II")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("1. First tablet of "), _c('i', [_vm._v("Enûma elish")]), _vm._v(", after the ta[blet . . . .],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("2. A copy from Babylon; written like its original [and collated].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("3. The tablet of Nabû-mush"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ê")]), _vm._v("tiq-ûmi, the son of [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("4. He who fears Marduk and "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int9.jpg"
    }
  }), _vm._v("arpan"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("î")]), _vm._v("[tu shall not take it away illegitimately]")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("5. Or withhold (it) from use "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v(". . . ."), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("6. The month of Iyyar, the ninth day, the twenty-seventh year of D[arius].")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("TABLET II")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("1. After Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat had made str[ong] preparations,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("2. She made ready to join battle with the gods her offspring.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("3. "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v("To avenge"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(" Apsû, Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat did (this) evil.")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabII-4"
    }
  }, [_vm._v("4. How she got ready for the attack was revealed to Ea.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("5. When Ea heard of this matter,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("6. He became benumbed with f[ea]r and sat in silent gloom.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("7. Af[ter he had] reflected on (the matter) and his wrath had subsided,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("8. He went to Anshar, his (grand)father.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("9. And when he had [co]me into the presence of Anshar, his grandfather,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("10. He communicated to him all that Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat had planned."), _c('a', {
    attrs: {
      "id": "page_26"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabII-11"
    }
  }, [_vm._v("11. “My father, Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, our bearer, hates us.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("12. She held a meeting and raged furiously.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("13. All the gods went over to her;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("14. Even those whom ye have created march at her side.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("15. They separated themselves(?) and went over to the side of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("16. They were angry, they plotted, not resting day or night;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("17. They took up the fight, fuming and raging;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("18. They held a meeting and planned the conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("19. Mother "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int7a1.jpg"
    }
  }), _vm._v("ubur, who fashions all things,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("20. Added (thereto) irresistible weapons, bearing monster serpents")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("21. Sharp of tooth and not sparing the fang(?).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("22. With poison instead of blood she filled their bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("23. Ferocious dragons she clothed with terror,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("24. She crowned them with fear-inspiring glory (and) made them like gods,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("25. So that he who would look upon them should perish from terror,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("26. So that their bodies might leap forward and none turn back their breasts.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("27. She set up the viper, the dragon,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn52",
      "id": "ffn52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" and the "), _c('i', [_vm._v("la"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("28. The great lion, the mad dog, and the scorpion-man,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("29. Driving storm demons, the dragonfly, and the bison,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("30. Bearing unsparing weapons, unafraid of battle.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("31. Powerful are her decrees, irresistible are they.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("32. Altogether(?) eleven (kinds of monsters) of this sort she brought into being.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("33. Of those among the gods, her first-born, who formed her assembly,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("34. She exalted Kingu; in their midst she made him great.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("35. To march at the head of the army, to direct the forces,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("36. To raise the weapons for the engagement, to launch the attack,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("37. The high command of the battle,"), _c('a', {
    attrs: {
      "id": "page_27"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("38. [She int]rusted to his hand; she caused him to sit in the assembly, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("39. ‘[I have] cast the spell for thee, I have made thee great in the assembly of the gods.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("40. The dominion over all the gods I have given [into thy h]and.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("41. Mayest thou be highly exalted, thou, my unique spouse!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("42. [May] thy names become greater than (those of) [the Anun]naki!’")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("43. [She ga]ve him the tablet of destinies, she fa[sten]ed (it) upon his breast, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("44. ‘[As for thee], thy command shall not be changed, the word of thy mouth shall be dependable!’")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("45. Now when Kingu had been exalted (and) had received supreme dominion,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("46. They decreed the destinies of [the gods], her sons, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("47. ‘May [the opening] of your months quiet the fire-god!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("48. May [thy overpowering poison] vanquish the (opposing) might!’"), _c('span', {
    staticClass: "sfs"
  }), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("49. [When Anshar heard that Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("ma]t was stirred profoundly,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("50. [He smote his thigh and] bit his lip."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn53",
      "id": "ffn53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("51. [His heart was full of gloom], his body did not rest.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("52. [. . . .] he suppresses his groaning.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("53. [He says to Ea: “Arise, my son, go to] battle!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("54. [The weapon which thou ha]st made thou shalt bear.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("55. Thou hast slain Apsû [. . . .];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("56. [Slay thou also(?) Kin]gu, who goes before her.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("57. [. . . .] wisdom.”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("58. Nudi[mmud, the counselor of the gods, answered him, (saying:)]")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("59–70. ("), _c('i', [_vm._v("Destroyed. The break no doubt recorded Nudimmud’s, i.e., Ea’s, failure")]), _vm._v(","), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn54",
      "id": "ffn54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('i', [_vm._v("even though he had succeeded in defeating Apsû. Anshar then turns to his son Anu")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("71. [. . . . Anshar cr]ied out [. . . .] in anger(?);")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("72. [To Anu], his son, he spoke [a word], (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("73. “[My first-born], thou there! my mighty hero,"), _c('a', {
    attrs: {
      "id": "page_28"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("74. Whose [po]wer is [great], whose onslaught is irresistible,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("75. [Go a]nd stand thou before Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("76. [That] her spirit [become quiet and] her heart calm down.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("77. [If] she does not hearken to thy word,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("78. Speak our [word(?)] to her, that she may be quieted.”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("79. [When he had heard] the words of his father, Anshar,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("80. [He took a direct rou]te to her and pursued the way to her.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("81. Anu [drew nigh], but perceiving the (strategic) plan of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("82. And [not being able to withstand her], he turned back."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn55",
      "id": "ffn55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("83. [He went in terror to] his [father], Anshar.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("84. [Concerning Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat thus he] spoke to him:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("85. “[. . .] . of her hand is . . . . upon me!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("86. Anshar lapsed into silence, looking upon the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("87. He shakes his locks,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn56",
      "id": "ffn56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" shaking his head at Ea.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("88. All the Anunnaki were assembled at the place.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("89. Their lips were closed, [they sat in] silence.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("90. “No god whatever can go t[o battle]")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("91. (And) escape w[ith his life] from the presence of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat.”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("92. Lord Anshar, the father of the gods, [arose in] majesty;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("93. His heart [prom]pted (him) [to speak to the Anunnaki]:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("94. “[He] whose [strength] is mighty shall be the avenger of [his] father.")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabII-95"
    }
  }, [_vm._v("95. [That one is] the . . . . in battle, the valia[nt] Mar[duk]!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("96. Ea called [Marduk] to [his] private room;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("97. [He ad]vised"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn57",
      "id": "ffn57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" (him), telling him the plan"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn58",
      "id": "ffn58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" of his heart:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("98. “Marduk, consider my idea, hearken to thy father.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("99. Thou art he, my son, who relieves his heart;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("100. Draw nigh [into the presence of] Anshar, (ready) for battle(?);")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("101. [Speak and] stand forth; when he sees thee, he will be at rest.”"), _c('a', {
    attrs: {
      "id": "page_29"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("102. The lord"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn59",
      "id": "ffn59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" was glad at the word of his father;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("103. He drew nigh and stood before Anshar.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("104. When Anshar saw him, his heart was filled with joy;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("105. He kissed his lips, his fear was removed.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("106. “[Anshar], be not silent, (but) open thy lips;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn60",
      "id": "ffn60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabII-107"
    }
  }, [_vm._v("107. I will go and accomplish all that is in thy heart!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("108. [Yea, Anshar], be not silent, (but) open thy lips;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("109. [I will g]o and accomplish all that is in thy heart!")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabII-110"
    }
  }, [_vm._v("110. What man is it who has brought battle against thee?")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("111. [. . . . T]i"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, who is a woman, is coming against thee with arms!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("112. [My father, c]reator, be glad and rejoice;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("113. Soon thou shalt trample upon the neck of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("114. [Yea, my father, c]reator, be glad and rejoice;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("115. Soon thou shalt trample upon [the neck of] Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("116. “My [so]n, who knowest all wisdom,")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabII-117"
    }
  }, [_vm._v("117. Quiet [Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat] with thy holy incantation.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("118. On the storm [chari]ot(?) quickly pursue (the way)!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("119. [. . . .] . . . . turn (her) back!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("120. The lord [was glad] at the word of his father;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("121. His heart [ex]ulted, and he said to his father:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("122. “Lord of the gods, destiny of the great gods,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn61",
      "id": "ffn61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("123. If I am indeed to be your avenger,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("124. To vanquish Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat and to keep you alive,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("125. Convene the assembly and proclaim my lot supreme.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("126. When ye are joyfully seated together in the Court of Assembly,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("127. May I through the utterance of my mouth determine the destinies, instead of"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn62",
      "id": "ffn62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" you."), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("128. Whatever I create shall remain unaltered,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("129. The command of my lips shall not return (void), it shall not be changed.”")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("CATCH LINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Anshar opened his mouth")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("COLOPHON I")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("1. Second [tablet of] "), _c('i', [_vm._v("Enûma elish;")]), _vm._v(" [written] according to [the tablet]")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("2. [. . . .], a copy from Ashur.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("3. [. . . . . . . . . . . . . . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("COLOPHON II")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("1. Written [like] its [original] and collated. The tablet of Nabû-a"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ê")]), _vm._v("-iddina,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("2. [The son of] Etir-b"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ê")]), _vm._v("l, the son of a priest of the god Mash."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn63",
      "id": "ffn63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" One shall not withhold (it) from use.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("TABLET III")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("1. Anshar opened his mouth")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("2. And addressed (these) words to Kaka, his vizier:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("3. “Kaka, my vizier, who gladdenest my heart,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("4. Unto La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _vm._v("mu (and) La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu I will send thee;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("5. Thou knowest (how) to [disce]rn (and) art able to relate.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("6. Cause the gods my fathers to be brought before me.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("7. [Let] them bring all the gods to me!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("8. Let them converse (and) sit down to a banquet.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("9. Let them eat bread (and) prepare wine."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn64",
      "id": "ffn64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("10. For [Marduk], their avenger, let them decree the destiny.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("11. Set out, O Kaka, go, and stand thou before them.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("12. What I am about to tell thee repeat unto them:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("13. ‘Anshar, your son, has sent me.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("14. [The command of] his heart he has charged me to convey,")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIII-15"
    }
  }, [_vm._v("15. [Saying: “Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("]mat, our bearer, hates us.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("16. She he[ld a meeting] and raged furiously.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("17. All the gods went over to her;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("18. Even those whom ye have created march at her side.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("19. They separated themselves(?) and went over to the side of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("20. They were angry, they plotted, not resting day or night;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("21. They took up the fight, fuming and raging;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("22. They held a meeting and planned the conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("23. Mother "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int7a1.jpg"
    }
  }), _vm._v("ubur, who fashions all things,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("24. Added (thereto) irresistible weapons, bearing monster serpents")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("25. Sharp of tooth and not sparing the fang(?).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("26. With poison instead of blood she filled their bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("27. Ferocious dragons she clothed with terror,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("28. She crowned them with fear-inspiring glory (and) made them like gods,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("29. So that [they] might cause him who would look upon them to perish from terror,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("30. So that their bodies might leap forward and none turn back their breasts.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("31. She set up the viper, the dragon, and the "), _c('i', [_vm._v("la"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")])]), _vm._v("["), _c('i', [_vm._v("mu")]), _vm._v("],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("32. The great lion, the mad dog, and the scorpion-man,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("33. Driving storm demons, the dragonfly, and the bison,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("34. Bearing unsparing weapons, unafraid of battle.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("35. Powerful are her decrees, irresistible are they."), _c('a', {
    attrs: {
      "id": "page_32"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("36. Altogether(?) eleven (kinds of monsters) of this sort she brought [into being].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("37. Of those among the gods, her first-born, who formed her [assembly],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("38. She exalted Kingu; in their midst she made [him gr]eat.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("39. To march at the head of the army, to [direct the forces],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("40. [To rai]se the weapons for the engagement, to la[unch the attack],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("41. The high com[mand of the b]attle,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("42. [She intrusted] to his hand; she caused him to sit [in the assembly], (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("43. ‘[I have ca]st the spell for thee, [I have made thee great] in the assembly of the gods.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("44. The dominion over all the gods [I have given] into thy hand.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("45. [Mayest] thou be highly exalted, [thou], my unique spouse!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("46. May thy names become greater than (those of) [the [Anunnaki]!’")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("47. She gave him the tablet of destinies, she fastened (it) upon his breast, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("48. ‘As for thee, thy command shall not be changed, the word of thy mouth shall be dependable!’")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("49. Now when Kingu had been exalted (and) had received supreme dominion,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("50. They decreed the destinies of the gods, her sons, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("51. ‘May the opening of your mouths quiet the fire-god!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("52. May thy overpowering poison vanquish the (opposing) might!’")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("53. I sent Anu, (but) he could not face her.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("54. Nudimmud (also) was afraid and turned back.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("55. (Then) Marduk, the wisest of the gods, your son, came forward.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("56. His heart prompted (him) to face Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("57. He opened his mouth (and) said to me:")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIII-58"
    }
  }, [_vm._v("58. ‘If I am indeed to be your avenger,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("59. To vanquish Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat and to keep you alive,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("60. Convene the assembly and proclaim my lot supreme."), _c('a', {
    attrs: {
      "id": "page_33"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("61. When ye are joyfully seated together in the Court of Assembly,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("62. May I through the utterance of my mouth determine the destinies, instead of you.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("63. Whatever I create shall remain unaltered,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("64. The command of my lips shall not return (void), it shall not be changed.’")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIII-65"
    }
  }, [_vm._v("65. Hasten to me (then) and speedily fix for him your destiny,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("66. That he may go to meet your powerful enemy!”"), _c('span', {
    staticClass: "sfs"
  }), _vm._v("’"), _c('span', {
    staticClass: "sfs"
  }), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("67. Kaka went and pursued his way.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("68. Before La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _vm._v("mu and La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu, the gods his ancestors,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("69. He prostrated himself and kissed the ground at their feet;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("70. He sat up, stood forth, and said to them:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("71. “Anshar, your son, has sent me.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("72. The command of his heart he has charged me to convey,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("73. Saying: ‘Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, our bearer, hates us.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("74. She held a meeting and raged furiously.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("75. All the gods went over to her;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("76. Even those whom ye have created march at her side.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("77. They separated themselves(?) and went over to the side of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("78. They were angry, they plotted, not resting day or night;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("79. They took up the fight, fuming and raging;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("80. They held a meeting and planned the conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("81. Mother "), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int7a1.jpg"
    }
  }), _vm._v("ubur, who fashions all things,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("82. Added (thereto) irresistible weapons, bearing monster serpents")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("83. Sharp of tooth and not sparing the fang(?).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("84. With poison instead of blood she filled their bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("85. Ferocious dragons she clothed with terror,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("86. She crowned them with fear-inspiring glory (and) made them like gods,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("87. So that he who would look upon them should perish from terror,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("88. So that their bodies might leap forward and none turn back their breasts."), _c('a', {
    attrs: {
      "id": "page_34"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("89. She set up the viper,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn65",
      "id": "ffn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" the dragon,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" and the "), _c('i', [_vm._v("la"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("90. The great lion,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" the mad dog,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" and the scorpion-man,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("91. Driving storm demons, the dragonfly, and the bison,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("92. Bearing unsparing weapons, unafraid of battle.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("93. Powerful are her decrees, irresistible are they.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("94. Altogether(?) eleven (kinds of monsters) of this sort she brought into being.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("95. Of those among the gods, her first-born, who formed her assembly,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("96. She exalted Kingu; in their midst she made him great.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("97. To march at the head of the army, to direct the forces,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("98. To raise the weapons for the engagement, to launch the attack,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("99. The high command of the battle,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("100. She intrusted to his hand; she caused him to sit in the assembly, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("101. “I have cast the spell for thee, I have made thee great in the assembly of the gods.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("102. The dominion over all the gods I have given into thy hand.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("103. Mayest thou be highly exalted, thou, my unique spouse!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("104. May thy names become greater than (those of) the Anunna[ki]!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("105. She gave him the tablet of destinies, [she fastened (it) upon his breast], (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("106. “As for thee, thy command shall not [be changed, the word of thy mouth shall be dependable]!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("107. Now when Kingu had been exa[lted (and) had received supreme dominion],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("108. [They decreed] the des[tinies] to the gods, her sons, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("109. “[May] the opening of your mouths [quiet the fire-god]!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("110. [May] thy overpowering poison [vanquish] the (opposing) mi[ght]!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("111. I sent Anu, (but) he [could] not [face her].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("112. Nudimmud (also) was afraid and [turned back]."), _c('a', {
    attrs: {
      "id": "page_35"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("113. (Then) Marduk, the wisest of [the gods, your son], came forward.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("114. [His heart prompted (him)] to face Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("115. He opened his mouth (and) [said to me]:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("116. “If I am indeed to be [your avenger],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("117. To vanquish Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat (and) [to keep you alive],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("118. Convene the assembly and [proclaim my lot supreme].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("119. [When ye are joyfully seated together] in the Court of Assembly,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("120. [May I] through the utterance of my mouth [determine the destinies], instead of [you].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("121. Whatever I create shall remain unaltered,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("122. The command of [my lips] shall not return (void), it shall [not be] changed.”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("123. Hasten to me (then) and speedily [fix for him] your destiny,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("124. [That he may] go to meet your powerful enemy!’"), _c('span', {
    staticClass: "sfs"
  }), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("125. When La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _vm._v("a"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn66",
      "id": "ffn66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" (and) La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu heard (this), they cried aloud;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("126. All the Igigi wailed painfully:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("127. “What has happened that she has come to [such a de]cision?")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("128. We do not understand Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat’s ac[tion]!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("129. They gathered together and departed,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("130. All the great gods who determine [the destinies].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("131. They entered into the presence of Anshar and filled [the Court of Assembly];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("132. They kissed one another [as they came together] in the assembly;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("133. They conversed (and) [sat down] to a banquet.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("134. They ate bread (and) prepared w[ine].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("135. The sweet wine dispelled their fears;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn67",
      "id": "ffn67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("136. [Their] bod[ies] swelled as they drank the strong drink.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("137. Exceedingly carefree were they, their spirit was exalted;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn68",
      "id": "ffn68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("138. For Marduk, their avenger, they decreed the destiny."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn69",
      "id": "ffn69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("CATCH LINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("They erected for him a lordly throne-dais.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("TABLET IV")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("1. They erected for him a lordly throne-dais,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn70",
      "id": "ffn70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("2. And he took his place before his fathers to (receive) sovereignty.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("3. “Thou art (the most) important among the great gods;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("4. Thy destiny is unequaled, thy command is (like that of) Anu."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn71",
      "id": "ffn71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("5. Marduk, thou art (the most) important among the great gods,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("6. Thy destiny is unequaled, thy command is (like that of) Anu.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("7. From this day onward thy command shall not be changed.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("8. To exalt and to abase—this shall be thy power!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("9. Dependable shall be the utterance of thy mouth, thy command shall not prove vain.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("10. None among the gods shall infringe upon thy prerogative."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn72",
      "id": "ffn72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("11. Maintenance is the requirement of the sanctuaries of the gods;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("12. And so at (each) place of their shrines shall be appointed a place for thee.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("13. Marduk, thou art our avenger;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("14. To thee we have given kingship over the totality of the whole universe,"), _c('a', {
    attrs: {
      "id": "page_37"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("15. So that when thou sittest in the assembly, thy word shall be exalted.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("16. May thy weapons not miss, may they smite thy foes.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("17. O lord, preserve the life of him who puts his trust in thee;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("18. But as for the god who has espoused evil, pour out his life!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn73",
      "id": "ffn73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIV-19"
    }
  }, [_vm._v("19. Then they placed a garment in their midst;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("20. To Marduk, their first-born, they said:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("21. “Thy destiny,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn74",
      "id": "ffn74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" O lord, shall be supreme among the gods.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("22. Command to destroy and to create, (and) they shall be!")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIV-23"
    }
  }, [_vm._v("23. By the word of thy mouth, let the garment be destroyed;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("24. Command again, and let the garment be whole!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("25. He commanded with his mouth, and the garment was destroyed.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("26. He commanded again, and the garment was restored."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn75",
      "id": "ffn75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("27. When the gods his fathers beheld the power of his word,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn76",
      "id": "ffn76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("28. They were glad (and) did homage, (saying:) “Marduk is king!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("29. They bestowed upon him the scepter, the throne, and the royal robe(?);")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("30. They gave him an irresistible weapon smiting the enemy, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("31. “Go and cut off the life of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("32. May the winds carry her blood to out-of-the-way places.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn77",
      "id": "ffn77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("33. After the gods his fathers had determined the destiny of B"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ê")]), _vm._v("l,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn78",
      "id": "ffn78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("34. They set him on the road—the way to success and attainment.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("35. He made a bow and decreed (it) as his weapon;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("36. An arrowhead he put (on the arrow and) fastened the bowstring to it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn79",
      "id": "ffn79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("37. He took up the club and grasped (it) in his right hand;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("38. The bow and the quiver he hung at his side.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("39. The lightning he set before him;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("40. With a blazing flame he filled his body."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn80",
      "id": "ffn80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("41. He made a net to inclose Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat within (it),")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("42. (And) had the four winds take hold that nothing of her might escape;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("43. The south wind, the north wind, the east wind, (and) the west wind,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("44. The gift of his (grand)father, Anu, he caused to draw nigh to the border(s) of the net.")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIV-45"
    }
  }, [_vm._v("45. He created the "), _c('i', [_vm._v("im"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _vm._v("ullu:")]), _vm._v(" the evil wind, the cyclone, the hurricane,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("46. The fourfold wind, the sevenfold wind, the whirlwind, the wind incomparable.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("47. He sent forth the winds which he had created, the seven of them;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("48. To trouble Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat within, they arose behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIV-49"
    }
  }, [_vm._v("49. The lord raised the rain flood,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn81",
      "id": "ffn81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" his mighty weapon.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("50. He mounted (his) irresistible, terrible storm chariot;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("51. He harnessed for it a team of four and yoked (them) to it,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("52. The Destructive, the Pitiless, the Trampler,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn82",
      "id": "ffn82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" the Flier.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("53. They were sharp of tooth, bearing poison;"), _c('a', {
    attrs: {
      "id": "page_39"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("54. They knew how to destroy, they had learned to overrun;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("55. [. . . .] they [smo]te, they were frightful in battle;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("56. To the left [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("57. He was clad in a terrifying coat of mail;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("58. Terror-inspiring splendor he wore on his head.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("59. The lord took a direct (route) and pursued his way;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("60. Toward the place of raging Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat he set his face.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("61. Between his lips he holds [a talisman(?)] of red paste;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("62. An herb to destroy the poison he grasped in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("63. Then the gods r[un] about him, the gods run about him;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("64. The gods his fathers run about him, the gods run about him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("65. The lord drew nigh to look into the heart of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("66. (And) to see the plan of Kingu, her spouse.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("67. As he"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn83",
      "id": "ffn83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" gazes, (Kingu) is confused in his plan;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("68. Destroyed is his will and disordered his action.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("69. As for the gods his helpers, who were marching at his side,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("70. When they saw the valiant hero, their vision became blurred.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("71. Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat set up a "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v("roar(?)"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(" without turning her neck,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("72. Upholding with her li[ps] (her) meanness(?) (and) rebellion:"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn84",
      "id": "ffn84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("73. “"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v(". . . ."), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(" . . have the gods risen up to thee?")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("74. (Or) have they gathered from their [place] to thy place?”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn85",
      "id": "ffn85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("75. Then the lord [raised] the rain flood, his mighty weapon."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn86",
      "id": "ffn86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("76. [As for T]i"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, who was furious, thus he answered her:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("77. “[In arrogance(?)] thou art risen (and) hast highly exalted thyself(?).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("78. [Thou hast caused] thy heart to plot the stirring-up of conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("79. [. . . .] the sons treat their fathers unjustly;"), _c('a', {
    attrs: {
      "id": "page_40"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("80. (And) thou, their bearer, dost hate (them) wi[thout cause(?)].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("81. Thou hast exalted Kingu to be [thy] spouse;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("82. Thine illegal [authority] thou hast set up in place of the authority of Anu.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("83. [Against] Anshar, the king of the gods, thou seekest evil,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("84. And hast proven thy wickedness [against the god]s my fathers.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("85. Let thine army be equipped! let them be girded with thy weapons!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("86. Come thou forth (alone) and let us, me and thee, do single combat!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("87. When Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat heard this,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("88. She became like one in a frenzy (and) lost her reason.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("89. Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat cried out loud (and) furiously,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("90. To the (very) roots her two legs shook back and forth.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("91. She recites an incantation, repeatedly casting her spell;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("92. As for the gods of battle, they sharpen their weapons.")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIV-93"
    }
  }, [_vm._v("93. Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat (and) Marduk, the wisest of the gods, advanced against one another;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("94. They pressed on"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn87",
      "id": "ffn87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" to single combat, they approached for battle.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("95. The lord spread out his net and enmeshed her;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("96. The evil wind, following after, he let loose in her face.")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIV-97"
    }
  }, [_vm._v("97. When Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat opened her mouth to devour him,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("98. He drove in the evil wind, in order that (she should) not (be able) to close her lips.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("99. The raging winds filled her belly;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("100. Her belly became distended,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn88",
      "id": "ffn88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" and she opened wide her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("101. He shot off an arrow, and it tore her interior;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("102. It cut through her inward parts, it split (her) heart.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("103. When he had subdued her, he destroyed her life;"), _c('a', {
    attrs: {
      "id": "page_41"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("104. He cast down her carcass (and) stood upon it.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("105. After he had slain Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, the leader,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("106. Her band broke up, her host dispersed."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn89",
      "id": "ffn89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("107. As for the gods her helpers, who marched at her side,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("108. They trembled for fear (and) faced about."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn90",
      "id": "ffn90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("109. They tried to break away to save their lives,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("110. (But) they were completely surrounded, (so that) it was impossible to flee.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("111. He imprisoned them and broke their weapons.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("112. In the net they lay and in the snare they were;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("113. They hid in the corners (and) were filled with lamentation;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("114. They bore his wrath, being confined in prison.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("115. As for the eleven (kinds of) creatures which she had laden with terror-inspiring splendor,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("116. The host of demons that marched "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v("impetuously before"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(" her,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("117. He cast (them) into fetters (and) [tied(?)] their arms [together(?)];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("118. With (all) their resistance, [he tr]ampled (them) underfoot.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("119. As for Kingu, who had become chief among them,")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIV-120"
    }
  }, [_vm._v("120. He bound him and counted him among the dead gods."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn91",
      "id": "ffn91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("121. He took from him the tablet of destinies, which was not his rightful possession.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("122. He sealed (it) with (his) seal and fastened (it) on his breast."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn92",
      "id": "ffn92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("123. After he had vanquished (and) subdued his enemies,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("124. Had overpowered the arrogant foe like a bull(?),")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("125. Had fully established Anshar’s victory over the enemy,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("126. Had attained the desire of Nudimmud,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn93",
      "id": "ffn93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" the valiant Marduk")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("127. Strengthened his hold upon the captive gods;")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIV-128"
    }
  }, [_vm._v("128. And then he returned to Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, whom he had subdued.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("129. The lord trod upon the hinder part of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("130. And with his unsparing club he split (her) skull.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("131. He cut the arteries of her blood")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("132. And caused the north wind to carry (it) to out-of-the-way places.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("133. When his fathers"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn94",
      "id": "ffn94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" saw (this), they were glad and rejoiced")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("134. (And) sent him dues (and) greeting-gifts.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("135. The lord rested, examining her dead body,")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIV-136"
    }
  }, [_vm._v("136. To divide the abortion"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn95",
      "id": "ffn95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" (and) to create ingenious things (therewith).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("137. He split her open like a mussel(?) into two (parts);")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("138. Half of her he set in place and formed the sky (therewith) as a roof.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("139. He fixed the crossbar (and) posted guards;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("140. He commanded them not to let her waters escape."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn96",
      "id": "ffn96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("141. He crossed the heavens and examined the regions.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("142. He placed himself opposite the "), _c('i', [_vm._v("Apsû")]), _vm._v(", the dwelling of Nudimmud.")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabIV-143"
    }
  }, [_vm._v("143. The lord measured the dimensions of the "), _c('i', [_vm._v("Apsû")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("144. And a great structure, its"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn97",
      "id": "ffn97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" counterpart, he established, (namely,) Esharra,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("145. The great structure Esharra which he made as a canopy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn98",
      "id": "ffn98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("146. Anu, Enlil, and Ea he (then) caused to inhabit their residences."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn99",
      "id": "ffn99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("CATCH LINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He created stations for the great gods.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("COLOPHON")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("1. 146 lines. Fourth tablet of "), _c('i', [_vm._v("Enûma elish")]), _vm._v(". Incomplete."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn100",
      "id": "ffn100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("2. Written according to a tablet whose text was crossed out.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("3. Nabû-b"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ê")]), _vm._v("lshu, (the son of) Na"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _vm._v("id-Marduk, the son of a smith, wrote (it) for the life of his soul")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("4. And the life of his house and deposited (it) in (the temple) Ezida."), _c('a', {
    attrs: {
      "id": "page_44"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("TABLET V")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("1. He created stations for the great gods;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("2. The stars their likeness(es), the signs of the zodiac, he set up.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("3. He determined the year, defined the divisions;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("4. For each of the twelve months he set up three constellations.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("5. After he had def[ined] the days of the year [by means] of constellations,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("6. He founded the station of N"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("î")]), _vm._v("biru"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn101",
      "id": "ffn101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" to make known their duties(?)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn102",
      "id": "ffn102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("7. That none might go wrong (and) be remiss,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("8. He established the stations of Enlil and Ea"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn103",
      "id": "ffn103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" together with it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn104",
      "id": "ffn104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("9. He opened gates on both sides,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn105",
      "id": "ffn105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("10. And made strong lock(s) to the left and to the right.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("11. In the very center thereof he fixed the zenith.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("12. The moon he caused to shine forth; the night he intrusted (to her).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("13. He appointed her, the ornament of the night, to make known the days.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("14. “Monthly without ceasing go forth"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn106",
      "id": "ffn106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" with a tiara."), _c('a', {
    attrs: {
      "id": "page_45"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("15. At the beginning of the month, namely, of the rising o[ver] the land,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("16. Thou shalt shine with horns to make known six days;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("17. On the seventh day with [hal]f a tiara.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("18. At the full moon thou shalt stand in opposition (to the sun), in the middle of each [month]."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn107",
      "id": "ffn107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("19. When the sun has [overtaken] thee on the foundation of heaven,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn108",
      "id": "ffn108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("20. Decrease [the tiara of full] light"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn109",
      "id": "ffn109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" and form (it) backward.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("21. [At the period of invisi]bility draw near to the way of the sun,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("22. And on [the twenty-ninth] thou shalt stand in opposition to the sun a second time."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn110",
      "id": "ffn110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("23. [. . . .] omen, enter upon her way.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("24. [. . . . ap]proach and render judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("25. [. . . .] to violate.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("26. [. . . .] to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("("), _c('i', [_vm._v("Break")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("CATCH LINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As [Marduk] hears [the word]s of the gods.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("COLOPHON")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fifth tablet (of) "), _c('i', [_vm._v("Enûma elish")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Palace of Ashurbanipal, king of the world, king of Assyria."), _c('a', {
    attrs: {
      "id": "page_46"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("TABLET VI")]), _vm._v(" "), _c('p', {
    staticClass: "list",
    attrs: {
      "id": "tabVI-1"
    }
  }, [_vm._v("1. As [Mar]duk hears the words of the gods,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn111",
      "id": "ffn111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVI-2"
    }
  }, [_vm._v("2. His heart prompts (him) to create ingenious things.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("3. He conveys his idea to Ea,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("4. Imparting the plan [which] he had conceived in his heart:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("5. “Blood"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn112",
      "id": "ffn112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" will I form and cause bone to be;")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVI-6"
    }
  }, [_vm._v("6. Then will I set up "), _c('i', [_vm._v("lullû")]), _vm._v(", ‘Man’ shall be his name!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("7. Yes, I will create "), _c('i', [_vm._v("lullû:")]), _vm._v(" Man!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("8. (Upon him) shall the services of the gods be imposed that they may be at rest.")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVI-9"
    }
  }, [_vm._v("9. Moreover, I will ingeniously arrange the ways of the gods."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn113",
      "id": "ffn113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("10. They shall be honored alike, but they shall be divided into two (groups).”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("11. Ea answered him, speaking a word to him,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("12. To make him change his mind concerning the relief of the gods:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("13. “Let a brother of theirs be delivered up;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("14. Let him be destroyed and men be fashioned.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("15. Let the great gods assemble hither,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("16. Let the guilty one be delivered up, and let them"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn114",
      "id": "ffn114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" be established.”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("17. Marduk assembled the great gods,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("18. Ordering (them) kindly (and) giving instructions.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("19. The gods pay attention to his word,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("20. As the king addresses a word to the Anunnaki, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("21. “Verily, the former thing which we declared unto you has come true!"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn115",
      "id": "ffn115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("22. (Also now) I speak the truth under an oath(?) by myself."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn116",
      "id": "ffn116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVI-23"
    }
  }, [_vm._v("23. Who was it that created the strife,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("24. And caused Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat to revolt and prepare for battle?")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("25. Let him who created the strife be delivered up;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("26. I will make him bear his punishment, be ye at rest.”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("27. The Igigi, the great gods, answered him,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn117",
      "id": "ffn117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("28. The “king of the gods of heaven and earth,” the counselor of the gods, their lord:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("29. “Kingu it was who created the strife,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn118",
      "id": "ffn118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("30. And caused Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat to revolt and prepare for battle.”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("31. They bound him and held him before Ea;")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVI-32"
    }
  }, [_vm._v("32. Punishment they inflicted upon him by cutting (the arteries of) his blood.")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVI-33"
    }
  }, [_vm._v("33. With his blood they created mankind;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("34. He"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn119",
      "id": "ffn119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" imposed the services of the gods (upon them) and set the gods free."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn120",
      "id": "ffn120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("35. After Ea, the wise, had created mankind,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("36. (And) they had imposed the service of the gods upon them"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn121",
      "id": "ffn121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v("—")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVI-37"
    }
  }, [_vm._v("37. That work was not suited to (human) understanding;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("38. In accordance with the ingenious plans of Marduk did Nudimmud"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn122",
      "id": "ffn122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" create (it)—,")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVI-39"
    }
  }, [_vm._v("39. Marduk, the king, divided")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("40. The totality of the Anunnaki above and below;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn123",
      "id": "ffn123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("41. He assigned (them) to Anu, to guard his decrees.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("42. Three hundred he set in the heavens as a guard.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("43. Moreover, the ways of (the gods of) the earth he defined."), _c('a', {
    attrs: {
      "id": "page_48"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("44. In heaven and in earth six hundred he caused to dwell."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn124",
      "id": "ffn124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVI-45"
    }
  }, [_vm._v("45. After he had issued all the decrees,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("46. (And) to the Anunnaki of heaven and earth had allotted their portions,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("47. The Anunnaki opened their mouth(s)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("48. And said to Marduk, their lord:")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVI-49"
    }
  }, [_vm._v("49. “Now, O lord, who hast established our freedom from compulsory service,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn125",
      "id": "ffn125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("50. What shall be the sign of our gratitude before thee?")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("51. Come, let us make (something) whose name shall be called ‘Sanctuary.’")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("52. It shall be a dwelling for our rest at night; come, let us repose therein!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("53. There let us erect a throne dais, a seat with a back support!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("54. On the day that we arrive,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn126",
      "id": "ffn126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" we will repose in it.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn127",
      "id": "ffn127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124a")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("55. When Marduk heard this,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("56. His countenance shone exceedingly, [lik]e the day, (and he said:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("57. "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v("”So(?)"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(" shall Babylon be, whose construction ye have desired;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("58. Let its brickwork be fashioned, and call (it) a sanctuary.”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("59. The Anunnaki wielded the hoe.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("60. One year they made bricks for it;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("61. When the second year arrived,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("62. They raised the head of Esagila"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn128",
      "id": "ffn128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" on high, level with the "), _c('i', [_vm._v("Apsû")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn129",
      "id": "ffn129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("63. After they had built the lofty stagetower of the "), _c('i', [_vm._v("Apsû")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("64. They established an abode therein(?) for Marduk, Enlil, (and) Ea.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("65. He"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn130",
      "id": "ffn130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" sat down before them in majesty,"), _c('a', {
    attrs: {
      "id": "page_49"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("66. As from the base of Esharra they look(ed) up to its horns."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn131",
      "id": "ffn131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("67. After they had completed the construction of Esagila,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("68. The Anunnaki built themselves shrines.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("69. "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v(". . . . all"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(" of them were gathered.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("70. "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v("They sat"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(" in the elevated shrine which they had built as his dwelling.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("71. He had the gods his fathers sit down to a banquet.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("72. “Here is Babylon, your favorite dwelling place.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("73. Make music in [its] place (and) be seated on its square(?).”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("74. When the great gods had sat down,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("75. The beer jug they set on, while they were seated at the banquet.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("76. After they had made music in it,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("77. They held a service of supplication in awe-inspiring(?) Esagila.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("78. The (laws pertaining to) portents were fixed, all the omens.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("79. The stations in heaven and earth the gods allotted, all of them.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("80. The fi[fty] great gods took their seats;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("81. And then the seven gods (determining) the destinies set three hundred (gods) [in the heavens].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("82. Enlil lifted up the b[ow, his"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn132",
      "id": "ffn132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v("] we[apon(?)], (and) laid (it) before them.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("83. The net which he had made the gods his fathers beheld.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("84. When they saw the bow, how skilfully its construction was made,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("85. His fathers praised the work which he had done.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("86. Anu lifted (it) up and spoke in the assembly of the gods.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("87. He kissed the bow, (saying:) “This [. . . .].”"), _c('a', {
    attrs: {
      "id": "page_50"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("88. He named the names of the bow as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("89. “Longwood is the first (name); the seco[nd is . . .];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("90. Its third name is Bow-Star; in heaven [. . . .].”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("91. He established its place [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("92. After [he had determined] the destinies of [the Bow-Star],")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("93. He set up a throne [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("94. A second one(?) in heaven [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("95. [The great gods ga]thered [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("96. [. . . .] Marduk [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("97–98. ("), _c('i', [_vm._v("Almost completely destroyed")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("99. He gave him [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("100. For the dominion over the go[ds(?) . . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("101. He made surpassing [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("102. For his names [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("103. He opened [his] mouth [and . . . .]:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("104. “At his command [. . . .] shall be supreme [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("105. Let him be highly exalted "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v(". . . ."), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("106. Let his high-priesthood be supreme "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v(". . . ."), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVI-107"
    }
  }, [_vm._v("107. Let him exercise shepherdship over mankind, [his] crea[tures(?)].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("108. Throughout the days to come let them, without forgetting, make mention of [his deeds(?)].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("109. Let him establish great offerings for his fathers;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("110. Let them provide for their maintenance (and) let them take care of their sanctuaries."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn133",
      "id": "ffn133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("111. May he provide (the gods) with burnt offerings to smell; their incantations may be "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v(". . . ."), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("112. A likeness of what he made(?) in heaven [let him make(?)] on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("113. Let him teach mankind to "), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec1.jpg"
    }
  }), _vm._v("fear him(?)"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/rec2.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("114. Let the subjects be ever mindful of their god (and) their goddess.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("115. At the opening of his mouth, let them pay attention to (their) goddess.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("116. Let offerings be brought for their god (and) their goddess;"), _c('a', {
    attrs: {
      "id": "page_51"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("117. Let their god be not forgotten, (but) let them support (him).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("118. Let them make their land shine by building shrines for themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("119. Let mankind stand (in awe) before our god.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("120. As for us, by as many a name as we have called (him), he shall be our god."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn134",
      "id": "ffn134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("121. Come, let us proclaim his fifty names!"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn135",
      "id": "ffn135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("122. Let his ways shine forth in glory, let his deeds be corresponding.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("123. "), _c('i', [_vm._v("Marduk")]), _vm._v(" (is the name) which Anu, his (grand)father, called him from his birth;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("124. The provider of pasture land and drinking places, who fills their stalls with plenty;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("125. Who with his weapon, the rain flood, overcame the enemies;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("126. Who saved the gods his fathers in distress.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("127. Verily, the sun-child of the gods, the radiant one, is he!"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn136",
      "id": "ffn136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("128. In the brightness of his bright light let them walk about constantly.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("129. (Upon) the people, whom he created . . . .,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("130. He"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn137",
      "id": "ffn137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" imposed the services of the gods, and they were set at ease.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("131. At his command let there be creation, destruction, alleviation, mercy;"), _c('a', {
    attrs: {
      "id": "page_52"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("132. Let them look upon him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("133. "), _c('i', [_vm._v("Marukka")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn138",
      "id": "ffn138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" verily is "), _c('i', [_vm._v("the")]), _vm._v(" god, the crea[tor of every]thing;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("134. Who gladdened the hearts of the Anunnaki, who put their [minds] at ease.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("135. "), _c('i', [_vm._v("Marutukku")]), _vm._v(" verily is the refuge of the land, the pro[tection of] his [people];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("136. Him the people shall praise [. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("137. "), _c('i', [_vm._v("Barashakushu")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn139",
      "id": "ffn139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" stood up and seized the reins (of the land);")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("138. Wide is his heart, (all-)embracing(?) [his] mind.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("139. "), _c('i', [_vm._v("Lugaldimmerankia")]), _vm._v(" is his name which we named in our assembly;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn140",
      "id": "ffn140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("140. The commands of his mouth we have exalted above (those of) the gods his fathers.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("141. Verily, he is the lord of all the gods of heaven and earth;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("142. The king at whose instruction the gods above and below shall be afraid."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn141",
      "id": "ffn141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("143. "), _c('i', [_vm._v("Narilugaldimmerankia")]), _vm._v(" is his name which we named; who takes care of all the gods;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("144. Who in heaven and earth established our dwelling place in (the time of) trouble;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("145. Who allotted stations to the Igigi and the Annunaki.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("146. At (the mention of) his name the gods shall quake (and) tremble in (their) dwelling(s).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("147. "), _c('i', [_vm._v("Asarlu"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _vm._v("i")]), _vm._v(" is his name by which Anu, his (grand)father, called (him);")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("148. Verily, he is the light of the gods, the mighty prince;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("149. Who, as a "), _c('i', [_vm._v("sh"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("ê")]), _vm._v("du")]), _vm._v(" and "), _c('i', [_vm._v("lamassu")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn142",
      "id": "ffn142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" of the gods and of the land,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("150. In mighty combat saved our dwelling in (the time of) trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("151. Asarlu"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _vm._v("i they secondly called "), _c('i', [_vm._v("Namtillaku")]), _vm._v(", the god who restores to life;"), _c('a', {
    attrs: {
      "id": "page_53"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("152. Who restored all the ruined gods, as though they were his own creation;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("153. The lord who by his holy incantation restored the dead gods to life;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("154. The destroyer of the insidious(?) enemies; come, let us extol [his] valor!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("155. Asarlu"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _vm._v("i, whose name was thirdly called "), _c('i', [_vm._v("Namshub;")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn143",
      "id": "ffn143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("156. The bright god who brightens our way.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("157. Anshar, La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _vm._v("mu, and La"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8a1.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mu each proclaimed three of his names.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("158. To the gods their sons they said:")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("159. “We have each proclaimed three of his names.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("160. Like unto us, proclaim ye (also) his names.”")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("161. The gods rejoiced and listened to their command.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("162. They took counsel together in the Court of Assembly, (saying:)")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("163. “Of the valiant son, our avenger")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("164. (And) our provider, let us exalt his name!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn144",
      "id": "ffn144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("165. So they sat down in their assembly to proclaim his destinies,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn145",
      "id": "ffn145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("166. All of them mentioning his name(s) in the holy place(?).")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("CATCH LINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Asaru")]), _vm._v(", the bestower of arable land, who has established [the gran]aries.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("TABLET VII"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn146",
      "id": "ffn146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("1. "), _c('i', [_vm._v("Asaru")]), _vm._v(", the bestower of arable land, [who has established the granaries];")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVII-2"
    }
  }, [_vm._v("2. The creator of grain and legumes, who cau[ses the green herb to spring up]."), _c('a', {
    attrs: {
      "id": "page_54"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("3. "), _c('i', [_vm._v("Asaralim")]), _vm._v(", who carries weight in the house of counsel, [who excels in counsel];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("4. (On whom) the gods did wait, (for) fear [had taken hold on them].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("5. "), _c('i', [_vm._v("Asaralimnunna")]), _vm._v(", the mighty one, the light of [the father of his begetter];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("6. Who directs the decrees of Anu, Enlil, [and Ea];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("7. He alone is their provider, who assigns [their dwelling places];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("8. Whose spear provides abundance.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("9. "), _c('i', [_vm._v("Tutu")]), _vm._v(", the author of their restoration, [is he];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("10. Let him purify their sanctuaries, that they [be at ease];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("11. Let him create incantations for the gods that [they be at rest];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("12. If they rise in anger, let them turn back [their breasts];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("13. Verily, he is highly exalted in the assembly of the gods!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("14. No one among the gods can e[qual] him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("15. Tutu is "), _c('i', [_vm._v("Ziukinna")]), _vm._v(", the life of the host of [the gods];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("16. Who established the bright heavens for the gods;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("17. Who took control of their ways and assigned [their courses(?)];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("18. May he not be forgotten among men, (but) [let them hold his] deeds (in remembrance).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("19. Tutu they thirdly called "), _c('i', [_vm._v("Ziku")]), _vm._v(", the maintainer of purification;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("20. The god of the good breath (of life), the lord who hears and answers (prayer);")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("21. The creator of riches and plenty, the establisher of abundance;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn147",
      "id": "ffn147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("22. Who has turned all our wants into plenty;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("23. Whose good breath (of life) we smelled in sore distress;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("24. Let them declare, exalt, (and) make glorious his praise.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("25. Tutu may the people, in the fourth place, magnify as "), _c('i', [_vm._v("Agaku;")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("26. The lord of the holy incantation, who restores to life the dead;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("27. Who had compassion on the vanquished gods;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("28. Who removed the yoke imposed upon the gods, his enemies;")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVII-29"
    }
  }, [_vm._v("29. Who created mankind to set them free;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn148",
      "id": "ffn148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("30. The merciful, in whose power it is to give life;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("31. May his words endure and not be forgotten")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("32. In the mouths of mankind, whom his hands have created.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("33. Tutu is, in the fifth (place), "), _c('i', [_vm._v("Tuku;")]), _vm._v(" may their mouth(s) at all times employ(?) his holy incantation;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("34. Who with his holy incantation extirpated all the evil ones.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("35. "), _c('i', [_vm._v("Shazu")]), _vm._v(", who knows the hearts of the gods, who sees through"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn149",
      "id": "ffn149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" the innermost parts;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("36. From whom the evildoer cannot escape;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("37. The establisher of the assembly of the gods, [who] gladdens their hearts;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("38. Their wide [protec]tion, the subduer of the disobedient;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("39. The administrator of justice, who pu[ts an end to(?)] crooked speech;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("40. Who in his place discerns falsehood and truth.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("41. Shazu may they secondly exalt as "), _c('i', [_vm._v("Zisi")]), _vm._v(", who sil[ences] the insurgent;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("42. Who drove the benumbing fear out of the bodies of the gods his fathers.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("43. Shazu is, thirdly, "), _c('i', [_vm._v("Su"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _vm._v("rim")]), _vm._v(", who destroys all (his) enemies with (his) weapon.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("44. Who frustrates their plans (and) scatters (them) to the winds;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("45. Who annihilates all the wicked ones, . . . .;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("46. Let the gods rejoice, (but) let "), _c('i', [_vm._v("them")]), _vm._v(" tremble(?)!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("47. Shazu is, in the fourth (place), "), _c('i', [_vm._v("Su"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _vm._v("gurim")]), _vm._v(", who grants petitions, who created (anew) the gods his fathers;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("48. Who extirpates the enemies (and) destroys their offspring;"), _c('a', {
    attrs: {
      "id": "page_56"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("49. Who shatters their works, not letting anything of them remain;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("50. Let his name be declared (and) uttered in the land.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("51. Shazu is, in the fifth (place), "), _c('i', [_vm._v("Za"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _vm._v("rim;")]), _vm._v(" let them extol(?) (him) as the lord(?) of the living(?);")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("52. Who destroys all the enemies, who requites (both) good and evil;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("53. Who brought all the fugitive gods back to their sanctuaries;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("54. May this his name endure!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("55. In the sixth (place), may they, in addition, worship Shazu everywhere as "), _c('i', [_vm._v("Za"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _vm._v("gurim;")])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("56. Who destroyed all the enemies as if in a battle.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("57. "), _c('i', [_vm._v("Enbilulu")]), _vm._v(", the lord who provides them with plenty, is he;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("58. The mighty one, who called them by their names, who established offerings of baked goods;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("59. Who regulates pasture (and) drinking places (and) has established (them) for the land;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("60. Who has opened the fountains (and) has apportioned water in abundance(?).")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("61. Let them secondly glorify Enbilulu as "), _c('i', [_vm._v("Epadun")]), _vm._v(", the lord who waters the field(?);")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("62. The ruler of heaven (and) earth, the establisher of furrows, who regulates the arable land and the pasture land(?),")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("63. The canal and (its) embankment, who designed the furrow.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("64. Let them thirdly praise Enbilulu as "), _c('i', [_vm._v("Gugal")]), _vm._v(", the administrator of the plantations of the gods;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("65. The lord of plenty, abundance, (and) heavy crops;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("66. The provider of wealth, who enriches all(?) the dwelling places;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("67. The giver of emmer, who causes barley to be.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("68. Enbilulu is "), _c('i', [_c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int7.jpg"
    }
  }), _vm._v("egal")]), _vm._v(", who stores up plenty for man’s consumption;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("69. Who causes abundance to rain down upon the wide earth (and) makes the green herb grow luxuriantly."), _c('a', {
    attrs: {
      "id": "page_57"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("70. "), _c('i', [_vm._v("Sirsir")]), _vm._v(","), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn150",
      "id": "ffn150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" who heaped up a mountain over(?) Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("71. Who with his weapon dragged off(?) the body of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("72. The guardian of the land, their faithful shepherd;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("73. . . . . . . . . . . . . . . . . . . . . .;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("74. Who crosses the wide sea in its anger,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("75. As a bridge passes over the place of conflict.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("76. Sirsir they secondly called "), _c('i', [_vm._v("Mala"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  })]), _vm._v(", and so forth;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("77. The sea is his craft upon which he rides.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("78. "), _c('i', [_vm._v("Gil")]), _vm._v(", who heaps up heaps of grain, fat hills;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("79. The creator of barley and emmer, who provides seed for the land.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("80. "), _c('i', [_vm._v("Gilma")]), _vm._v(", the establisher of the "), _c('i', [_vm._v("durma"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  })]), _vm._v(" of the gods, the creator of enduring things;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("81. The bond that holds the family(?) together, the provider of good things.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("82. "), _c('i', [_vm._v("Agilma")]), _vm._v(", the sublime, who tears off the crown, [. . . .];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("83. The creator of the clouds above the waters, the establisher of [the heavens].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("84. "), _c('i', [_vm._v("Zulum")]), _vm._v(", who assigns the fiel[ds. . . .];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("85. The giver of portions and offerings, who supe[rvises. . . .].")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("86. Zulum is secondly "), _c('i', [_vm._v("Mummu")]), _vm._v(", the creator of heaven (and) earth, who directs the cl[ouds];")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("87. The god who purifies heaven and earth;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("88. To whom no one among the gods is equal in power.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("89. "), _c('i', [_vm._v("Gishnumunab")]), _vm._v(", the creator of all men, the maker of the four regions of the earth;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("90. The destroyer of the gods of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, who created mankind with their bodies(?)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn151",
      "id": "ffn151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("91. "), _c('i', [_vm._v("Lugalabdubur")]), _vm._v(", the king who shattered the works of Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, who took away her weapons;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("92. Whose foundation is firmly established before and behind.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("93. "), _c('i', [_vm._v("Pagalguenna")]), _vm._v(", the first of all the lands, the one whose strength is mighty;"), _c('a', {
    attrs: {
      "id": "page_58"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("94. Who is highly exalted among the gods his brothers, the lord of all of them.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("95. "), _c('i', [_vm._v("Lugaldurma"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  })]), _vm._v(", the king, the bond of the gods, the lord of the "), _c('i', [_vm._v("durma"), _c('img', {
    staticClass: "mid",
    attrs: {
      "alt": "image",
      "src": "img/int8.jpg"
    }
  }), _vm._v(";")])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("96. Who is highly exalted in the abode of kingship, who is very prominent among the gods.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("97. "), _c('i', [_vm._v("Aranunna")]), _vm._v(", the counselor of Ea, the creator of the gods his fathers;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("98. Whom no god whatever can equal in his princely way.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("99. "), _c('i', [_vm._v("Dumuduku")]), _vm._v(", whose holy dwelling is renovated in Duku;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("100. Dumuduku, without whom Lugaldukuga"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn152",
      "id": "ffn152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" does not make a decision.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("101. "), _c('i', [_vm._v("Lugallanna")]), _vm._v(", the king whose might is exalted among the gods;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("102. The lord, the power of Anu, who surpasses the name(?) of Anshar.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("103. "), _c('i', [_vm._v("Lugalugga")]), _vm._v(", who dragged off all of them into the midst of the sea;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("104. Who possesses all wisdom, who has a broad understanding.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("105. "), _c('i', [_vm._v("Irkingu")]), _vm._v(", who dragged off Kingu into the . . . . of the battle;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("106. Who controls the instructions for all, the establisher of rulership.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("107. "), _c('i', [_vm._v("Kinma")]), _vm._v(", the leader of all the gods, the giver of counsel;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("108. At whose name the gods tremble for fear, as at the storm.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("109. "), _c('i', [_vm._v("Esiskur")]), _vm._v("—may he sit on a high seat in the house of prayer;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("110. May the gods bring their gifts before him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("111. (From him) they receive their assignments;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("112. Without him no one can create ingenious things;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("113. The four (groups of) mankind are his creation;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn153",
      "id": "ffn153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("114. Besides him no god whatever knows the appointed time(?) of their days.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("115. "), _c('i', [_vm._v("Girru")]), _vm._v(", the establisher of the . . . of the weapon;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("116. Who in (his) conflict with Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat creates ingenious things;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("117. The one with a wide understanding, an intelligent mind,"), _c('a', {
    attrs: {
      "id": "page_59"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("118. (And) an unsearchable heart, which the gods in their totality cannot fathom.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("119. "), _c('i', [_vm._v("Addu")]), _vm._v(" shall be his name; may he cover the whole sky;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("120. May his beautiful thunder be mighty(?) upon the earth;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("121. May (his) thunder rend(?) the clouds and give sustenance to the people below.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("122. "), _c('i', [_vm._v("Asharu")]), _vm._v(", who, as his name (indicates), took care of the gods (determining) the destinies;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("123. With the nocturnal rest(?) of all the gods he is intrusted.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("124. "), _c('i', [_vm._v("N"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("î")]), _vm._v("biru")]), _vm._v(" shall be in control of the passages in heaven and on earth,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("125. For everyone above and below who cannot find the passage enquires of him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("126. N"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("î")]), _vm._v("biru is his star which they caused to shine in the sky;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("127. He has taken position at the solstitial point(?), may they look upon him,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("128. Saying: “He who crosses the middle of the sea without resting,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("129. His name shall be N"), _c('span', {
    staticClass: "sans"
  }, [_vm._v("î")]), _vm._v("biru, who occupies the middle thereof;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("130. May he maintain the course of the stars of heaven;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("131. May he shepherd all the gods like sheep;")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVII-132"
    }
  }, [_vm._v("132. May he subdue Ti"), _c('img', {
    staticClass: "sup1",
    attrs: {
      "alt": "image",
      "src": "img/int2.jpg"
    }
  }), _c('span', {
    staticClass: "sans"
  }, [_vm._v("â")]), _vm._v("mat, may he distress her life, and may it be short!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("133. Until future (generations of) men, when the (present) days have grown old,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("134. May she retreat without hindrance, may she withdraw forever!”")]), _vm._v(" "), _c('p', {
    staticClass: "listb",
    attrs: {
      "id": "tabVII-135"
    }
  }, [_vm._v("135. Since he created the (heavenly) places (and) fashioned the firm earth,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("136. Father Enlil called his name "), _c('i', [_vm._v("Lord of the Lands")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("137. All the names which the Igigi proclaimed,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("138. Ea heard and his spirit rejoiced,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("139. Saying: “He whose names his fathers have magnified,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("140. He is even as I; his name shall (therefore) be "), _c('i', [_vm._v("Ea")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("141. The totality of all my rites shall he control;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("142. All my ordinances shall he direct.”"), _c('a', {
    attrs: {
      "id": "page_60"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("143. With the name "), _c('i', [_vm._v("Fifty")]), _vm._v(" the great gods")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("144. Called (him) whose names are fifty (and thus) made his way pre-eminent."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn154",
      "id": "ffn154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("EPILOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("145. Let them be held in remembrance and let the first one"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn155",
      "id": "ffn155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" teach (them);")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("146. Let the wise (and) the knowing consider (them) together;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("147. Let the father repeat (them) and teach (them) to his sons;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("148. Let the ears (even) of shepherd and herdsman be opened (to them)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/9780226112428_15_not#fn156",
      "id": "ffn156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])])]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("149. Let (man) rejoice in Marduk, the Enlil of the gods,")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("150. That his land be fruitful (and) it be well with him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("151. Reliable is his word, unalterable his command;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("152. The utterance of his mouth no god whatever can change.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("153. He looks on and does not turn his neck;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("154. When he is wroth, no god can withstand his indignation.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("155. Unsearchable is his heart, (all-)embracing his mind;")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("156. The sinner and the transgressor are an abom[ination] before him.")]), _vm._v(" "), _c('p', {
    staticClass: "listb"
  }, [_vm._v("157. The instructions which an ancient(?) one spoke before him(?).")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("("), _c('i', [_vm._v("Rest too fragmentary for translation")]), _vm._v(")"), _c('a', {
    attrs: {
      "id": "page_61"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fa439e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226112428_10_ch1.vue
// module id = 78
// module chunks = 0